;(function(){




(window.FPK = window.FPK || {}).hero = function (root, ctx) {
  var g=ctx.gsap, ST=ctx.ScrollTrigger, reduce=!!ctx.reduce, fine=!!ctx.fine, SplitType=ctx.SplitType;
  var rises=Array.prototype.slice.call(root.querySelectorAll('[data-h3-rise]'));
  var h1=root.querySelector('[data-h3-h1]'), photo=root.querySelector('[data-h3-photo]'), glance=root.querySelector('[data-h3-glance]');
  var rows=glance?Array.prototype.slice.call(glance.querySelectorAll('.fpk-h3-grow')):[];
  var capEl=root.querySelector('[data-h3-count]');
  if(reduce||!g){ return; }
  var tl=g.timeline();
  if(h1){ g.set(h1,{y:30,opacity:0}); tl.to(h1,{y:0,opacity:1,duration:.65,ease:'back.out(1.5)',clearProps:'transform'},0); }
  g.set(rises,{y:22,opacity:0}); tl.to(rises,{y:0,opacity:1,duration:.5,ease:'power3.out',stagger:.07},.12);
  if(photo){ g.set(photo,{y:26,opacity:0,scale:.97}); tl.to(photo,{y:0,opacity:1,scale:1,duration:.7,ease:'power3.out'},.15); }
  if(glance){ g.set(glance,{y:26,opacity:0}); tl.to(glance,{y:0,opacity:1,duration:.6,ease:'power3.out'},.22);
    g.set(rows,{x:10,opacity:0}); tl.to(rows,{x:0,opacity:1,duration:.4,ease:'power2.out',stagger:.05},.34); }
  if(capEl){ var o={v:0}; tl.to(o,{v:200,duration:1,ease:'power2.out',onUpdate:function(){capEl.textContent=Math.round(o.v);}},.4); }
  if(fine){ root.querySelectorAll('[data-h3-magnetic]').forEach(function(el){
    el.addEventListener('pointermove',function(e){var r=el.getBoundingClientRect();g.to(el,{x:(e.clientX-r.left-r.width/2)*.28,y:(e.clientY-r.top-r.height/2)*.32,duration:.4,ease:'power4.out'});});
    el.addEventListener('pointerleave',function(){g.to(el,{x:0,y:0,duration:.6,ease:'elastic.out(1,.5)'});});
  }); }
};




})();

;(function(){






(window.FPK = window.FPK || {}).trust = function (root, ctx) {
  var g = ctx.gsap, reduce = !!ctx.reduce;
  var items = Array.prototype.slice.call(root.querySelectorAll('.fpk-tr2-col > *'));
  if (reduce || !g) return;
  g.set(items, { y: 18, opacity: 0 });
  g.to(items, { y: 0, opacity: 1, duration: 0.5, ease: 'power3.out', stagger: 0.07,
    scrollTrigger: { trigger: root, start: 'top 85%' } });
};






})();

;(function(){







(window.FPK = window.FPK || {}).who = function(root, ctx){
  ctx = ctx || {};
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger, SplitType = ctx.SplitType;
  var reduce = !!ctx.reduce, fine = !!ctx.fine;

  var section = (root.classList && root.classList.contains('fpk-who-sec'))
    ? root : (root.querySelector('.fpk-who-sec') || root);
  var headline = root.querySelector('[data-fpk-headline]');
  var cards    = Array.prototype.slice.call(root.querySelectorAll('[data-fpk-card]'));
  var fill     = root.querySelector('[data-fpk-fill]');
  var mShine   = root.querySelector('[data-fpk-mshine]');
  var pLabel   = root.querySelector('[data-fpk-plabel]');
  var dash     = root.querySelector('.fpk-who-eyebrow-dash');
  var grid     = root.querySelector('.fpk-who-grid');
  var rises    = Array.prototype.slice.call(root.querySelectorAll('[data-fpk-rise]'));
  var TOTAL    = cards.length || 4;

  function paint(n){ if(pLabel) pLabel.textContent = n + ' / ' + TOTAL + ' profiles'; }

  // ---------- No GSAP or reduced motion: final resting state, no triggers ----------
  if(!gsap || reduce){
    if(fill) fill.style.transform = 'scaleX(1)';
    cards.forEach(function(c){ c.style.opacity = '1'; c.style.pointerEvents = 'auto'; });
    rises.forEach(function(r){ r.style.opacity = '1'; });
    if(headline) headline.style.opacity = '1';
    paint(TOTAL);
    return;
  }

  if(ST && gsap.registerPlugin){ try{ gsap.registerPlugin(ST); }catch(e){} }
  section.classList.add('fpk-anim'); // gate hidden states, set initials ASAP

  var E = { pop:'back.out(1.7)', snap:'back.out(2.4)', spring:'elastic.out(1,0.55)', settle:'power4.out', in:'power3.in' };

  // ---------- kinetic headline: mask + skew + scale reveal ----------
  var split = null;
  function buildSplit(){
    if(!SplitType || !headline) return null;
    try{
      var t = new SplitType(headline, { types:'lines' });
      t.lines.forEach(function(l){
        var w = document.createElement('span');
        w.className = 'fpk-who-line-mask';
        l.parentNode.insertBefore(w, l);
        w.appendChild(l);
      });
      return t;
    }catch(e){ return null; }
  }
  function revealHeadline(){
    if(headline) gsap.set(headline, { opacity:1 });
    split = buildSplit();
    if(split){
      gsap.set(split.lines, { yPercent:120, skewY:6, scaleY:1.15, transformOrigin:'left top', willChange:'transform' });
      gsap.to(split.lines, {
        yPercent:0, skewY:0, scaleY:1, duration:0.62, ease:E.pop, stagger:0.07,
        scrollTrigger:{ trigger:headline, start:'top 82%' },
        onComplete:function(){ gsap.set(split.lines, { clearProps:'transform,willChange' }); }
      });
    } else if(headline){
      gsap.set(headline, { yPercent:110, opacity:0 });
      gsap.to(headline, {
        yPercent:0, opacity:1, duration:0.62, ease:E.pop,
        scrollTrigger:{ trigger:headline, start:'top 82%' },
        onComplete:function(){ gsap.set(headline, { clearProps:'transform' }); }
      });
    }
  }
  revealHeadline();

  // re-split on resize so line masks don't clip after a reflow
  var rt;
  function onResize(){
    clearTimeout(rt);
    rt = setTimeout(function(){
      if(split){
        try{ split.revert(); }catch(e){}
        split = null;
        if(headline) gsap.set(headline, { clearProps:'all' });
      }
      ST && ST.refresh();
    }, 200);
  }
  window.addEventListener('resize', onResize);

  // ---------- eyebrow / meter rise + dash grow ----------
  gsap.set(rises, { y:32, opacity:0 });
  gsap.to(rises, {
    y:0, opacity:1, duration:0.5, ease:E.pop, stagger:0.06,
    scrollTrigger:{ trigger:section, start:'top 80%' },
    onComplete:function(){ gsap.set(rises, { clearProps:'transform' }); }
  });
  if(dash){
    gsap.fromTo(dash, { scaleX:0 }, {
      scaleX:1, duration:0.5, ease:E.pop,
      scrollTrigger:{ trigger:section, start:'top 80%' }
    });
  }

  // ---------- meter reset ----------
  if(fill) gsap.set(fill, { scaleX:0, transformOrigin:'left center' });
  paint(0);
  var counter = { v:0 };

  // ---------- master timeline: each card locks pop + badge spring + ring pulse + shine + meter notch + count ----------
  gsap.set(cards, {
    y:44, scale:0.9, opacity:0, willChange:'transform',
    rotate:function(i){ return i % 2 ? 2.5 : -2.5; }
  });

  var master = gsap.timeline({
    scrollTrigger:{ trigger:grid || section, start:'top 80%', once:true },
    onComplete:function(){ gsap.set(cards, { clearProps:'transform,willChange' }); }
  });

  cards.forEach(function(card, i){
    var shine = card.querySelector('[data-fpk-cardshine]');
    var badge = card.querySelector('[data-fpk-badge]');
    var ring  = card.querySelector('.fpk-who-badge-ring');
    var at = i * 0.14;

    // tile pops in — re-enable pointer-events the instant it starts revealing
    master.to(card, {
      y:0, scale:1, rotate:0, opacity:1, duration:0.55, ease:E.pop,
      onStart:function(){ card.style.pointerEvents = 'auto'; }
    }, at);

    if(badge){
      master.fromTo(badge, { scale:0.4, rotate:-40 }, {
        scale:1, rotate:0, duration:0.55, ease:E.spring,
        onComplete:function(){ gsap.set(badge, { clearProps:'transform' }); }
      }, at + 0.08);
    }
    if(ring){
      master.fromTo(ring, { opacity:0.9, scale:0.7 }, {
        opacity:0, scale:1.5, duration:0.7, ease:'power2.out',
        onComplete:function(){ gsap.set(ring, { clearProps:'transform' }); }
      }, at + 0.08);
    }
    if(shine){
      master.fromTo(shine, { xPercent:-170, opacity:0 }, {
        xPercent:260, opacity:1, duration:0.7, ease:'power2.inOut',
        onComplete:function(){ gsap.to(shine, { opacity:0, duration:0.2 }); }
      }, at + 0.1);
    }
    if(fill){
      master.to(fill, { scaleX:(i + 1) / TOTAL, duration:0.4, ease:'power3.out' }, at + 0.08);
    }
    master.to(counter, {
      v:i + 1, duration:0.4, ease:'power1.out', snap:{ v:1 },
      onUpdate:function(){ paint(Math.round(counter.v)); }
    }, at + 0.08);
    if(pLabel){
      master.to(pLabel, { scale:1.22, duration:0.14, ease:'power2.out', yoyo:true, repeat:1 }, at + 0.08);
    }
  });

  // meter shine once fully unlocked
  if(mShine){
    master.fromTo(mShine, { xPercent:-160, opacity:0 }, {
      xPercent:340, opacity:1, duration:0.7, ease:'power2.inOut',
      onComplete:function(){ gsap.to(mShine, { opacity:0, duration:0.2 }); }
    }, '>-0.1');
  }

  // ---------- per-card micro-interactions: magnetic pull-toward-cursor (baked lift) + shine + click ripple ----------
  // v2 parity: pure magnetic translation (x/y) only — NO 3D tilt. is-magnetic swaps the
  // CSS hover-lift for GSAP-driven motion so the two never fight.
  cards.forEach(function(card){
    var shine = card.querySelector('[data-fpk-cardshine]');
    if(!fine) return;

    card.classList.add('is-magnetic');
    // magnetic translation toward cursor — the y term bakes in a ~6px lift like v2
    var xTo = gsap.quickTo(card, 'x', { duration:0.45, ease:'power3' });
    var yTo = gsap.quickTo(card, 'y', { duration:0.45, ease:'power3' });

    card.addEventListener('pointerenter', function(){
      card.style.willChange = 'transform';
      if(shine){
        gsap.fromTo(shine, { xPercent:-170, opacity:1 }, {
          xPercent:260, opacity:1, duration:0.7, ease:'power2.inOut',
          onComplete:function(){ gsap.to(shine, { opacity:0, duration:0.2 }); }
        });
      }
    });

    // magnetically pull the card toward the cursor so it 'comes toward you' + rises
    card.addEventListener('pointermove', function(e){
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      xTo(px * 16);
      yTo(py * 12 - 6);
    });

    // release springs past 0 (overshoot) instead of damping to rest — matches v2 back.out(2)
    card.addEventListener('pointerleave', function(){
      gsap.to(card, {
        x:0, y:0, duration:0.6, ease:'back.out(2)',
        onComplete:function(){ card.style.willChange = 'auto'; }
      });
    });

    // green click ripple + recoil punch — 0.96 press, then the back.out release makes it snap back springy
    card.addEventListener('pointerdown', function(e){
      var r = card.getBoundingClientRect();
      var rp = document.createElement('span');
      rp.className = 'fpk-who-ripple';
      rp.style.left = (e.clientX - r.left) + 'px';
      rp.style.top = (e.clientY - r.top) + 'px';
      card.appendChild(rp);
      gsap.fromTo(rp, { scale:0, opacity:0.42 }, {
        scale:4, opacity:0, duration:0.6, ease:'power2.out',
        onComplete:function(){ rp.remove(); }
      });
      gsap.to(card, { scale:0.96, duration:0.09, ease:E.in, yoyo:true, repeat:1 });
    });
  });
};







})();

;(function(){







(window.FPK = window.FPK || {}).build = function (root, ctx) {
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger, SplitType = ctx.SplitType;
  var reduce = !!ctx.reduce, fine = !!ctx.fine;

  root.classList.add('fpk-anim');

  var head = root.querySelector('.fpk-build-head');
  var headline = root.querySelector('[data-headline]');
  var rises = gsap.utils.toArray(root.querySelectorAll('[data-rise]'));
  var stage = root.querySelector('[data-stage]');
  var viewport = root.querySelector('[data-viewport]');
  var track = root.querySelector('[data-track]');
  var cards = gsap.utils.toArray(root.querySelectorAll('[data-card]'));
  var progress = root.querySelector('[data-progress]');
  var countEl = root.querySelector('[data-count]');
  var segFills = gsap.utils.toArray(root.querySelectorAll('[data-seg-fill]'));
  var toast = root.querySelector('[data-toast]');

  // FIX 4: match v2's exit timing exactly — power3.in for `in`, plus a rush ease.
  var E = { pop:'back.out(1.7)', snap:'back.out(2.4)', spring:'elastic.out(1,0.55)', settle:'power4.out', rush:'power2.in', in:'power3.in' };

  var dragging = false;

  // FIX 1: v2's value-tween count-up ({v:0} -> N, power2.out, with grouping/suffix support).
  function fmt(n, group, suffix){
    return (group ? Math.round(n).toLocaleString('en-US') : String(Math.round(n))) + (suffix || '');
  }
  function countUp(el, to, dur, group, suffix){
    if(!el) return;
    var o = el._fpkCv || (el._fpkCv = { v: parseFloat(el.textContent) || 0 });
    gsap.to(o, { v:to, duration:dur||0.6, ease:'power2.out', overwrite:true,
      onUpdate:function(){ el.textContent = fmt(o.v, group, suffix); } });
  }

  function sweepShine(sh, delay){
    if(!sh) return;
    gsap.fromTo(sh, { xPercent:-160, opacity:0 },
      { keyframes:[{opacity:.6,duration:.12},{opacity:0}], xPercent:240, duration:.75, ease:'power2.inOut', delay:delay||0 });
  }

  // ---------- reduced motion: final resting state, no triggers ----------
  if (reduce) {
    root.classList.add('fpk-mode-native');
    gsap.set(rises, { clearProps:'all' });
    gsap.set(cards, { clearProps:'all', opacity:1 });
    if (progress) gsap.set(progress, { opacity:1 });
    if (countEl) countEl.textContent = String(cards.length);
    segFills.forEach(function(f){ gsap.set(f, { scaleX:1, transformOrigin:'left center' }); });
    return;
  }

  if (ST) gsap.registerPlugin(ST);

  // FIX 5: re-settle pin length + trigger positions once web fonts land (guards a late font
  // swap from mis-sizing the pin / mis-measuring travel via the function-based x + end).
  if (ST && document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function(){ ST.refresh(); });
  }

  // ---------- progress meter + achievement toast ----------
  var unlocked = 0, toastDone = false;
  function popToast(){
    if(!toast || toastDone) return; toastDone = true;
    gsap.timeline()
      .fromTo(toast, {opacity:0,scale:.6,y:-8}, {opacity:1,scale:1,y:0,duration:.55,ease:'back.out(2.6)'})
      .to(toast, {opacity:0,y:-12,scale:.96,duration:.45,ease:E.in,delay:2.8}); // FIX 4: power3.in exit
  }
  function bumpProgress(){
    if(unlocked >= cards.length) return;
    unlocked++;
    var f = segFills[unlocked-1];
    if(f) gsap.to(f, {scaleX:1,duration:.55,ease:'back.out(1.8)',transformOrigin:'left center'});
    if(countEl){
      countUp(countEl, unlocked, 0.6);                                     // FIX 1: smooth power2.out tally
      gsap.fromTo(countEl, {scale:1.45}, {scale:1,duration:.5,ease:'back.out(3)'}); // scale-pop kept as accent on top
    }
    if(unlocked >= cards.length) popToast();
  }

  // ---------- kinetic mask + skew headline ----------
  var split = null, headlineDone = false;
  function wrapLines(lines){
    lines.forEach(function(l){
      var w = document.createElement('span');
      w.className = 'fpk-build-linewrap';
      w.style.cssText = 'display:block;overflow:hidden';
      l.parentNode.insertBefore(w, l); w.appendChild(l);
    });
  }
  function buildSplit(){ if(!headline||!SplitType) return; if(split) split.revert(); split = new SplitType(headline, {types:'lines'}); wrapLines(split.lines); }
  function playHeadline(){
    if(headline && SplitType){
      buildSplit();
      gsap.set(split.lines, {yPercent:120,skewY:6,scaleY:1.15,transformOrigin:'left top'});
      gsap.to(split.lines, {yPercent:0,skewY:0,scaleY:1,duration:.64,ease:E.pop,stagger:.08,
        onComplete:function(){ headlineDone=true; gsap.set(split.lines,{clearProps:'transform'}); }});
    } else if(headline){ gsap.set(headline,{opacity:1}); }
  }
  function playRises(){
    gsap.set(rises, {y:30,opacity:0});
    gsap.to(rises, {y:0,opacity:1,duration:.55,ease:E.pop,stagger:.08,
      onComplete:function(){ gsap.set(rises,{clearProps:'transform'}); }});
  }
  function playProgress(){
    if(!progress) return;
    gsap.set(progress, {y:18,opacity:0});
    gsap.to(progress, {y:0,opacity:1,duration:.5,ease:E.pop});
  }

  // ---------- cards: hidden -> slam in with overshoot + shine ----------
  gsap.set(cards, { opacity:0, y:46, scale:.88, rotate:function(i){ return i%2 ? 3 : -3; }, transformOrigin:'center bottom' });
  function revealCard(card, delay){
    if(card.dataset.rev) return; card.dataset.rev = '1';
    gsap.to(card, {opacity:1,y:0,scale:1,rotate:0,duration:.62,ease:E.snap,delay:delay||0,
      onComplete:function(){ gsap.set(card,{clearProps:'transform'}); card.dataset.settled='1'; }});
    sweepShine(card.querySelector('.fpk-build-shine'), (delay||0)+0.12);
  }

  // ---------- FIX 2 + FIX 3: hover tilt/depth/parallax + tactile press ----------
  function wireInteractions(){
    if(!fine) return;
    cards.forEach(function(card){
      var qy = gsap.quickTo(card, 'rotationY', {duration:.4, ease:E.settle});
      var qx = gsap.quickTo(card, 'rotationX', {duration:.4, ease:E.settle});
      var qz = gsap.quickTo(card, 'y',        {duration:.4, ease:E.settle}); // FIX 2: z-depth push
      // FIX 2: counter-parallax on inner elements (icon acts as card-top, name, label)
      var ico  = card.querySelector('.fpk-build-ico');
      var name = card.querySelector('.fpk-build-name');
      var lab  = card.querySelector('.fpk-build-lab');
      var iX = ico  ? gsap.quickTo(ico,'x',{duration:.4,ease:E.settle}) : null;
      var iY = ico  ? gsap.quickTo(ico,'y',{duration:.4,ease:E.settle}) : null;
      var nX = name ? gsap.quickTo(name,'x',{duration:.5,ease:E.settle}) : null;
      var nY = name ? gsap.quickTo(name,'y',{duration:.5,ease:E.settle}) : null;
      var lX = lab  ? gsap.quickTo(lab,'x',{duration:.5,ease:E.settle}) : null;
      var lY = lab  ? gsap.quickTo(lab,'y',{duration:.5,ease:E.settle}) : null;

      card.addEventListener('pointermove', function(e){
        if(dragging) return;
        var r = card.getBoundingClientRect();
        var px = (e.clientX - (r.left + r.width/2)) / (r.width/2);
        var py = (e.clientY - (r.top + r.height/2)) / (r.height/2);
        qy(px * 7); qx(-py * 7); qz(-6);                 // FIX 2: mirror v2's px*6 tilt + qz(-6) depth
        if(iX){ iX(px*10); iY(py*8); }                   // FIX 2: card-top-style parallax
        if(nX){ nX(px*5);  nY(py*4); }                   // FIX 2: name parallax
        if(lX){ lX(px*5);  lY(py*4); }                   // FIX 2: label parallax
      });
      card.addEventListener('pointerenter', function(){ if(!dragging) sweepShine(card.querySelector('.fpk-build-shine'), 0); });
      card.addEventListener('pointerleave', function(){
        gsap.to(card, {rotationX:0, rotationY:0, y:0, duration:.6, ease:E.spring, overwrite:'auto'}); // FIX 2: spring reset incl. depth
        if(iX){ iX(0); iY(0); }
        if(nX){ nX(0); nY(0); }
        if(lX){ lX(0); lY(0); }
      });

      // FIX 3: click ripple + 0.94 press-punch on pointerdown (v2's js-ripple tactile feel).
      // Guarded to settled cards so the punch never fights the reveal's scale tween.
      card.addEventListener('pointerdown', function(e){
        if(!card.dataset.settled) return;
        var r = card.getBoundingClientRect();
        var rp = document.createElement('span');
        rp.className = 'fpk-build-ripple';
        rp.style.left = (e.clientX - r.left) + 'px';
        rp.style.top  = (e.clientY - r.top)  + 'px';
        card.appendChild(rp);
        gsap.fromTo(rp, {scale:0,opacity:.5}, {scale:4,opacity:0,duration:.6,ease:'power2.out',onComplete:function(){ rp.remove(); }});
        gsap.to(card, {scale:.94,duration:.09,ease:E.in,yoyo:true,repeat:1}); // FIX 4: power3.in press
      });
    });

    // FIX 3: magnetic pull — wired and ready for when a CTA (.fpk-build-magnetic) is added to the cards.
    var cta = root.querySelector('.fpk-build-magnetic');
    if(cta){
      var s = 0.3;
      cta.addEventListener('pointermove', function(e){
        var r = cta.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width/2)) * s;
        var dy = (e.clientY - (r.top + r.height/2)) * s;
        gsap.to(cta, {x:dx,y:dy,duration:.4,ease:E.settle,overwrite:'auto'});
        var lbl = cta.querySelector('.fpk-build-magnetic-label');
        if(lbl) gsap.to(lbl, {x:dx*0.35,y:dy*0.35,duration:.4,ease:E.settle}); // label lag
      });
      cta.addEventListener('pointerleave', function(){
        gsap.to(cta, {x:0,y:0,duration:.6,ease:E.spring,overwrite:'auto'});
        var lbl = cta.querySelector('.fpk-build-magnetic-label');
        if(lbl) gsap.to(lbl, {x:0,y:0,duration:.6,ease:E.spring});
      });
    }
  }

  function resizeHook(){
    if(!ST) return;
    var rt;
    window.addEventListener('resize', function(){
      clearTimeout(rt);
      rt = setTimeout(function(){
        if(headline && SplitType && headlineDone){ buildSplit(); gsap.set(split.lines,{clearProps:'all'}); }
        ST.refresh();
      }, 220);
    });
  }

  var isNarrow = window.matchMedia && window.matchMedia('(max-width:820px)').matches;
  function fits(){ return track.scrollWidth <= viewport.clientWidth + 40; }

  // ---------- NATIVE (mobile / all-fit): reveal + native swipe ----------
  function nativeMode(){
    root.classList.add('fpk-mode-native');
    ST.create({trigger:head, start:'top 84%', once:true, onEnter:function(){ playHeadline(); playRises(); }});
    ST.create({trigger:(progress||viewport), start:'top 86%', once:true, onEnter:playProgress});
    ST.create({trigger:viewport, start:'top 84%', once:true, onEnter:function(){
      cards.forEach(function(card,i){ revealCard(card, i*0.09); });
      cards.forEach(function(_,i){ gsap.delayedCall(0.16*i, bumpProgress); });
    }});
    wireInteractions();
    resizeHook();
  }

  if (isNarrow) { nativeMode(); return; }
  if (fits())   { nativeMode(); return; }

  // ---------- PINNED CROSS-AXIS: scroll down -> cards travel sideways ----------
  root.classList.add('fpk-mode-pin');

  function travel(){ return Math.max(0, track.scrollWidth - viewport.clientWidth); }

  var activeCard = null;
  function updateActive(){
    var vr = viewport.getBoundingClientRect(), cx = vr.left + vr.width/2;
    var best=null, bestD=1e9;
    for(var i=0;i<cards.length;i++){
      var r = cards[i].getBoundingClientRect();
      var d = Math.abs(r.left + r.width/2 - cx);
      if(d < bestD){ bestD = d; best = cards[i]; }
    }
    if(best && best !== activeCard){
      if(activeCard) activeCard.classList.remove('is-active');
      best.classList.add('is-active'); activeCard = best;
      if(!best.dataset.counted){ best.dataset.counted = '1'; bumpProgress(); }
    }
  }

  var horiz = gsap.to(track, {
    x: function(){ return -travel(); },
    ease:'none',
    scrollTrigger:{
      trigger: stage, start:'top top', end:function(){ return '+=' + travel(); },
      scrub:0.5, pin:true, anticipatePin:1, invalidateOnRefresh:true,
      onUpdate: updateActive, onRefresh: updateActive
    }
  });

  /* auto-drift while pinned + idle (owner) — any input pauses; calm ~66px/s glide */
  (function(){
    var st = horiz.scrollTrigger;
    if(!st || reduce) return;
    var lastInput = Date.now();
    function poke(){ lastInput = Date.now(); }
    ['wheel','touchstart','pointerdown','keydown'].forEach(function(ev){
      window.addEventListener(ev, poke, { passive:true });
    });
    gsap.ticker.add(function(){
      if(!st.isActive) return;
      if(Date.now() - lastInput < 2000) return;
      if(st.progress >= 0.999) return;
      window.scrollBy(0, 1.54);  /* owner: +0.4x */
    });
  })();

  // intro reveal (fires as the stage rises in, just before it pins)
  ST.create({trigger:stage, start:'top 55%', once:true, onEnter:function(){
    playHeadline(); playRises(); playProgress();
    var vw = viewport.clientWidth, d = 0;
    cards.forEach(function(card){ if(card.offsetLeft < vw + 40){ revealCard(card, d); d += 0.1; } });
    updateActive();
  }});

  // reveal the off-screen cards as they traverse sideways into view
  cards.forEach(function(card){
    ST.create({trigger:card, containerAnimation:horiz, start:'left 88%', onEnter:function(){ revealCard(card, 0); }});
  });

  // ---------- drag to traverse (fine pointer) ----------
  var lastX = 0;
  if (fine) {
    viewport.addEventListener('pointerdown', function(e){
      dragging = true; lastX = e.clientX; viewport.classList.add('is-drag');
      try { viewport.setPointerCapture(e.pointerId); } catch(_){}
    });
    viewport.addEventListener('pointermove', function(e){
      if(!dragging) return;
      var dx = e.clientX - lastX; lastX = e.clientX;
      window.scrollBy(0, -dx * 1.15);
    });
    var endDrag = function(){ if(!dragging) return; dragging = false; viewport.classList.remove('is-drag'); };
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('lostpointercapture', endDrag);
  }

  wireInteractions();
  resizeHook();
};







})();

;(function(){
(window.FPK = window.FPK || {}).mentorband = function (root, ctx) {
  if (!root) return;
  ctx = ctx || {};
  var gsap = ctx.gsap || null;
  var ST = ctx.ScrollTrigger || null;
  var SplitType = ctx.SplitType || null;
  var reduce = !!ctx.reduce;
  var fine = !!ctx.fine;

  var track = root.querySelector('.fpk-mb4-track');
  var cards = track ? [].slice.call(track.querySelectorAll('.fpk-mb4-card')) : [];
  var dots = [].slice.call(root.querySelectorAll('.fpk-mb4-dot'));
  var countEl = root.querySelector('.fpk-mb4-count');

  /* ---- pagination dots <-> carousel (always wired) ---- */
  function nearestIndex() {
    if (!track || track.scrollWidth <= track.clientWidth + 4) return 0;
    var center = track.scrollLeft + track.clientWidth / 2;
    var best = 0, bd = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var mid = cards[i].offsetLeft + cards[i].offsetWidth / 2;
      var d = Math.abs(mid - center);
      if (d < bd) { bd = d; best = i; }
    }
    return best;
  }
  function paintDots(idx) {
    for (var i = 0; i < dots.length; i++) {
      var on = i === idx;
      dots[i].classList.toggle('fpk-mb4-dot--on', on);
      if (on) dots[i].setAttribute('aria-current', 'true');
      else dots[i].removeAttribute('aria-current');
    }
  }
  var raf = null;
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; paintDots(nearestIndex()); });
  }
  if (track) track.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      var card = cards[i];
      if (!card || !track) return;
      var left = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
      if (track.scrollTo) track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
      else track.scrollLeft = left;
      paintDots(i);
    });
  });
  paintDots(0);

  /* ---- reduced motion (or missing gsap): final visible states, no triggers, no loops ---- */
  if (reduce || !gsap) {
    root.classList.add('fpk-mb4-reduced');
    if (countEl) countEl.textContent = '+' + (parseInt(countEl.getAttribute('data-count'), 10) || 25);
    return;
  }

  root.classList.add('fpk-mb4-js');
  if (ST && gsap.registerPlugin) gsap.registerPlugin(ST);

  var eyebrow = root.querySelector('.fpk-mb4-eyebrow');
  var title = root.querySelector('.fpk-mb4-title');
  var foot = root.querySelector('.fpk-mb4-foot');
  var ambient = root.querySelector('.fpk-mb4-ambient');
  var sheens = [].slice.call(root.querySelectorAll('.fpk-mb4-ph-sheen'));
  var glints = [].slice.call(root.querySelectorAll('.fpk-mb4-chip-glint'));

  var words = null;
  if (SplitType && title) {
    try { words = new SplitType(title, { types: 'words', wordClass: 'fpk-mb4-w' }).words; }
    catch (e) { words = null; }
  }

  var target = countEl ? (parseInt(countEl.getAttribute('data-count'), 10) || 25) : 25;
  if (countEl) countEl.textContent = '+0';

  /* initial states set from JS so no-JS renders fully visible */
  if (eyebrow) gsap.set(eyebrow, { y: 16, opacity: 0 });
  if (words && words.length) gsap.set(words, { yPercent: 115, opacity: 0 });
  else if (title) gsap.set(title, { y: 26, opacity: 0 });
  if (cards.length) gsap.set(cards, { y: 56, opacity: 0, rotateX: 7, transformPerspective: 850, transformOrigin: '50% 100%' });
  if (foot) gsap.set(foot, { y: 14, opacity: 0 });

  var tl = gsap.timeline({
    defaults: { ease: 'power3.out' },
    scrollTrigger: ST ? { trigger: root, start: 'top 74%', once: true } : undefined
  });
  if (eyebrow) tl.to(eyebrow, { y: 0, opacity: 1, duration: 0.55 }, 0);
  if (words && words.length) tl.to(words, { yPercent: 0, opacity: 1, duration: 0.75, stagger: 0.055, ease: 'power4.out' }, 0.1);
  else if (title) tl.to(title, { y: 0, opacity: 1, duration: 0.7 }, 0.1);
  if (cards.length) tl.to(cards, { y: 0, opacity: 1, rotateX: 0, duration: 0.95, ease: 'back.out(1.4)', stagger: 0.09 }, 0.3);
  if (sheens.length) tl.fromTo(sheens, { xPercent: 0 }, { xPercent: 340, duration: 0.9, ease: 'power2.inOut', stagger: 0.09 }, 0.62);
  if (glints.length) tl.fromTo(glints, { xPercent: 0 }, { xPercent: 340, duration: 0.7, ease: 'power2.inOut', stagger: 0.09 }, 0.78);
  if (countEl) {
    var counter = { v: 0 };
    tl.to(counter, {
      v: target, duration: 1.15, ease: 'power2.out',
      onUpdate: function () { countEl.textContent = '+' + Math.round(counter.v); }
    }, 0.85);
  }
  if (foot) tl.to(foot, { y: 0, opacity: 1, duration: 0.6 }, 1.0);

  /* gentle band parallax on the ambient layer (scrubbed, not a loop) */
  if (ST && ambient) {
    gsap.to(ambient, {
      yPercent: 9, ease: 'none',
      scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 0.6 }
    });
  }

  /* ---- pointer micro-interactions: lift + soft 3D tilt + photo parallax + chip glint ---- */
  if (fine) {
    cards.forEach(function (card) {
      var inner = card.querySelector('.fpk-mb4-cardin');
      if (!inner) return;
      var fig = card.querySelector('.fpk-mb4-ph-fig');
      var halo = card.querySelector('.fpk-mb4-ph-halo');
      var glint = card.querySelector('.fpk-mb4-chip-glint');
      gsap.set(inner, { transformPerspective: 750 });
      var rX = gsap.quickTo(inner, 'rotationX', { duration: 0.55, ease: 'power3.out' });
      var rY = gsap.quickTo(inner, 'rotationY', { duration: 0.55, ease: 'power3.out' });
      var lY = gsap.quickTo(inner, 'y', { duration: 0.45, ease: 'power3.out' });
      var fX = fig ? gsap.quickTo(fig, 'x', { duration: 0.6, ease: 'power3.out' }) : null;
      var fY = fig ? gsap.quickTo(fig, 'y', { duration: 0.6, ease: 'power3.out' }) : null;
      var hX = halo ? gsap.quickTo(halo, 'x', { duration: 0.8, ease: 'power3.out' }) : null;

      card.addEventListener('pointerenter', function () {
        lY(-7);
        if (glint) gsap.fromTo(glint, { xPercent: 0 }, { xPercent: 340, duration: 0.7, ease: 'power2.inOut', overwrite: 'auto' });
      });
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        rX(py * -6);
        rY(px * 7);
        if (fX) fX(px * -9);
        if (fY) fY(py * -6);
        if (hX) hX(px * -14);
      });
      card.addEventListener('pointerleave', function () {
        rX(0); rY(0); lY(0);
        if (fX) fX(0);
        if (fY) fY(0);
        if (hX) hX(0);
      });
    });
  }
};
})();

;(function(){






(window.FPK = window.FPK || {}).mentor = function(root, ctx){
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger, SplitType = ctx.SplitType;
  var reduce = !!ctx.reduce;
  var fine = (ctx.fine != null) ? !!ctx.fine
           : !!(window.matchMedia && window.matchMedia('(pointer:fine)').matches);

  var copy     = root.querySelector('.fpk-mentor-copy');
  var headline = root.querySelector('[data-fpk-headline]');
  var rises    = Array.prototype.slice.call(root.querySelectorAll('[data-fpk-rise]'));
  var card     = root.querySelector('[data-fpk-card]');
  var av       = root.querySelector('[data-fpk-av]');
  var fill     = root.querySelector('[data-fpk-fill]');
  var count    = root.querySelector('[data-fpk-count]');
  var countSr  = root.querySelector('[data-fpk-count-sr]');
  var shine    = card ? card.querySelector('.fpk-mentor-card-shine') : null;
  var cta      = root.querySelector('.fpk-mentor-cta');
  var ctaShine = cta ? cta.querySelector('.fpk-mentor-cta-shine') : null;

  var foot     = root.querySelector('[data-fpk-foot]');
  var toast    = root.querySelector('[data-fpk-toast]');
  var toastShine = toast ? toast.querySelector('.fpk-mentor-card-toast-shine') : null;
  var badge    = root.querySelector('.fpk-mentor-card-badge');
  var livePill = root.querySelector('.fpk-mentor-card-live');

  var TARGET = 100;
  var SR_FINAL = '100% full-cohort presence';
  function setCount(v){ if(count) count.textContent = Math.round(v) + '%'; }
  /* single discrete announcement — the visual counter is aria-hidden so AT never re-reads tween frames */
  function announce(){ if(countSr) countSr.textContent = SR_FINAL; }

  var unlocked = false;
  /* ---- SIGNATURE PAYOFF: achievement toast pops (back.out(2.6)) + shine sweep + badge flash the moment the meter fills 100% ---- */
  function unlock(){
    if(unlocked) return; unlocked = true;
    if(!toast) return;
    if(reduce || !gsap){
      toast.style.opacity = '1';
      toast.style.transform = 'none';
      return;
    }
    var tl = gsap.timeline();
    tl.fromTo(toast, {opacity:0, scale:0.8, y:8},
      {opacity:1, scale:1, y:0, duration:0.5, ease:'back.out(2.6)'});
    if(toastShine){
      tl.fromTo(toastShine, {xPercent:-140, opacity:0.6},
        {xPercent:260, opacity:0.6, duration:0.7, ease:'power2.inOut',
         onComplete:function(){ gsap.set(toastShine, {opacity:0}); }}, 0.1);
    }
    if(badge){
      tl.fromTo(badge, {scale:1}, {scale:1.16, duration:0.22, yoyo:true, repeat:1, ease:'back.out(3)',
        clearProps:'transform'}, 0.04);
    }
    if(livePill){
      tl.fromTo(livePill, {scale:1}, {scale:1.1, duration:0.2, yoyo:true, repeat:1, ease:'back.out(3)',
        clearProps:'transform'}, 0.12);
    }
    if(fill){
      tl.fromTo(fill, {filter:'brightness(1)'}, {filter:'brightness(1.65)', duration:0.24, yoyo:true, repeat:1,
        ease:'power2.out', clearProps:'filter'}, 0);
    }
  }

  /* ---- REDUCE or no-GSAP: final visible resting states, NO ScrollTriggers/loops ---- */
  if(reduce || !gsap){
    root.classList.remove('fpk-js');
    setCount(TARGET);
    announce();
    unlock();
    if(fill) fill.style.transform = 'scaleX(1)';
    return;
  }

  root.classList.add('fpk-js'); /* fallback if the inline pre-paint script was stripped */
  var E = {pop:'back.out(1.7)', snap:'back.out(2.4)', spring:'elastic.out(1,0.55)', settle:'power4.out'};
  gsap.registerPlugin(ST);

  /* ---- SIGNATURE: kinetic headline — mask + skew + scaleY line reveal ---- */
  if(SplitType && headline){
    var split = new SplitType(headline, {types:'lines'});
    split.lines.forEach(function(l){
      var w = document.createElement('span');
      w.style.cssText = 'display:block;overflow:hidden';
      l.parentNode.insertBefore(w, l); w.appendChild(l);
    });
    gsap.set(split.lines, {yPercent:120, skewY:6, scaleY:1.15, transformOrigin:'left top'});
    gsap.set(headline, {opacity:1});
    gsap.to(split.lines, {
      yPercent:0, skewY:0, scaleY:1, duration:0.62, ease:E.pop, stagger:0.07,
      scrollTrigger:{trigger:copy || headline, start:'top 82%'},
      onComplete:function(){ gsap.set(split.lines, {clearProps:'transform'}); }
    });
  } else if(headline){
    gsap.set(headline, {opacity:1});
  }

  /* ---- eyebrow + body + CTA kinetic rise ---- */
  if(rises.length){
    gsap.set(rises, {y:34, opacity:0});
    gsap.to(rises, {
      y:0, opacity:1, duration:0.5, ease:E.pop, stagger:0.06,
      scrollTrigger:{trigger:root, start:'top 78%'},
      onComplete:function(){ gsap.set(rises, {clearProps:'transform'}); }
    });
  }

  /* ---- SIGNATURE: RK player card SNAPS in (crisp back.out overshoot), then avatar pop + shine sweep + XP meter ---- */
  if(card){
    if(count) setCount(0);
    gsap.set(card, {y:48, scale:0.9, opacity:0, rotate:2.5, transformOrigin:'50% 60%'});
    var played = false;
    gsap.to(card, {
      y:0, scale:1, opacity:1, rotate:0,
      duration:0.58, ease:E.snap,
      scrollTrigger:{trigger:card, start:'top 82%'},
      onStart:function(){
        if(played) return; played = true;
        if(av){
          gsap.fromTo(av, {scale:0.4, opacity:0, rotate:-8},
            {scale:1, opacity:1, rotate:0, duration:0.6, ease:E.snap, delay:0.1});
        }
        if(shine){
          gsap.fromTo(shine, {xPercent:-160, opacity:0.5},
            {xPercent:340, opacity:0.5, duration:0.8, ease:'power2.inOut', delay:0.26,
             onComplete:function(){ gsap.set(shine, {opacity:0}); }});
        }
        if(fill) gsap.fromTo(fill, {scaleX:0}, {scaleX:1, duration:0.8, ease:'back.out(1.8)', delay:0.2});
        if(count){
          var o = {v:0};
          gsap.to(o, {v:TARGET, duration:0.85, ease:'power2.out', delay:0.2,
            onUpdate:function(){ setCount(o.v); },
            onComplete:function(){ setCount(TARGET); announce(); unlock(); }});
        } else {
          announce(); unlock();
        }
      },
      onComplete:function(){ gsap.set(card, {clearProps:'transform'}); }
    });
  }

  /* ---- credit foot: LinkedIn link gets its OWN ScrollTrigger rise (mirrors reference's staggered foot beat) ---- */
  if(foot){
    gsap.set(foot, {y:28, opacity:0});
    gsap.to(foot, {
      y:0, opacity:1, duration:0.5, ease:E.pop,
      scrollTrigger:{trigger:foot, start:'top 90%'},
      onComplete:function(){ gsap.set(foot, {clearProps:'transform'}); }
    });
  }

  /* ---- micro: magnetic CTA + shine on hover (fine pointers) ---- */
  if(fine && cta){
    var mag = 0.3;
    cta.addEventListener('pointermove', function(e){
      var r = cta.getBoundingClientRect();
      gsap.to(cta, {x:(e.clientX-(r.left+r.width/2))*mag, y:(e.clientY-(r.top+r.height/2))*0.35,
        duration:0.4, ease:E.settle, overwrite:'auto'});
    });
    cta.addEventListener('pointerleave', function(){
      gsap.to(cta, {x:0, y:0, duration:0.6, ease:E.spring, overwrite:'auto'});
    });
    cta.addEventListener('pointerenter', function(){
      if(ctaShine) gsap.fromTo(ctaShine, {xPercent:-160}, {xPercent:260, duration:0.7, ease:'power2.inOut'});
    });
  }

  /* ---- click ripple + recoil on CTA (all pointers) ---- */
  if(cta){
    cta.addEventListener('pointerdown', function(e){
      var r = cta.getBoundingClientRect();
      var rp = document.createElement('span');
      rp.className = 'fpk-mentor-ripple';
      rp.style.left = (e.clientX-r.left)+'px';
      rp.style.top  = (e.clientY-r.top)+'px';
      cta.appendChild(rp);
      gsap.fromTo(rp, {scale:0, opacity:0.5}, {scale:4, opacity:0, duration:0.6, ease:'power2.out',
        onComplete:function(){ rp.remove(); }});
      gsap.to(cta, {scale:0.94, duration:0.09, yoyo:true, repeat:1, ease:'power1.in'});
    });
  }

  /* ---- card: shine sweep on hover + recoil punch + green ping on press (fine) ---- */
  if(fine && card){
    card.addEventListener('pointerenter', function(){
      if(shine) gsap.fromTo(shine, {xPercent:-160, opacity:0.5},
        {xPercent:340, opacity:0.5, duration:0.72, ease:'power2.inOut',
         onComplete:function(){ gsap.set(shine, {opacity:0}); }});
    });
    card.addEventListener('pointerdown', function(e){
      if(e.target && e.target.closest && e.target.closest('a')) return;
      gsap.to(card, {scale:0.985, duration:0.12, ease:'power2.out', overwrite:'auto',
        onComplete:function(){ gsap.to(card, {scale:1, duration:0.5, ease:E.snap, clearProps:'transform'}); }});
      var r = card.getBoundingClientRect();
      var rp = document.createElement('span');
      rp.className = 'fpk-mentor-ripple';
      rp.style.left = (e.clientX-r.left)+'px';
      rp.style.top  = (e.clientY-r.top)+'px';
      card.appendChild(rp);
      gsap.fromTo(rp, {scale:0, opacity:0.22}, {scale:3, opacity:0, duration:0.6, ease:'power2.out',
        onComplete:function(){ rp.remove(); }});
    });
  }
};






})();

;(function(){






(window.FPK = window.FPK || {}).outcomes = function(root, ctx){
  ctx = ctx || {};
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger, reduce = !!ctx.reduce, SplitType = ctx.SplitType;
  var fine = ctx.fine;
  if(fine === undefined){
    var mq = window.matchMedia && window.matchMedia('(pointer:fine)');
    fine = !!(mq && mq.matches);
  }

  var headline = root.querySelector('[data-fpk-headline]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fpk-card]'));
  var fill = root.querySelector('[data-fpk-fill]');
  var pShine = root.querySelector('[data-fpk-pshine]');
  var pLabel = root.querySelector('[data-fpk-plabel]');
  var rises = Array.prototype.slice.call(root.querySelectorAll('[data-fpk-rise]'));
  var TOTAL = cards.length || 6;

  function paint(n){ if(pLabel) pLabel.textContent = n + ' / ' + TOTAL + ' unlocked'; }

  // ---------- No GSAP or reduced motion: final resting state, no ScrollTriggers ----------
  if(!gsap || reduce){
    if(fill) fill.style.transform = 'scaleX(1)';
    cards.forEach(function(c){ c.style.opacity = '1'; c.style.pointerEvents = 'auto'; });
    rises.forEach(function(r){ r.style.opacity = '1'; });
    paint(TOTAL);
    return;
  }

  root.classList.add('fpk-anim'); // gate hidden states + lock initial states ASAP
  if(ST) gsap.registerPlugin(ST); // guarantee scrollTrigger configs are honored regardless of harness registration order

  var E = { pop:'back.out(1.7)', snap:'back.out(2.4)', spring:'elastic.out(1,0.55)', settle:'power4.out', in:'power3.in' };

  // ---------- kinetic headline: mask + skew + scale reveal (re-splittable) ----------
  var split = null;
  function buildSplit(){
    if(!SplitType || !headline) return null;
    try{
      var t = new SplitType(headline, { types:'lines' });
      t.lines.forEach(function(l){
        var w = document.createElement('span');
        w.className = 'fpk-oc-line-mask';
        l.parentNode.insertBefore(w, l);
        w.appendChild(l);
      });
      return t;
    }catch(e){ return null; }
  }
  function revealHeadline(){
    split = buildSplit();
    if(split){
      gsap.set(split.lines, { yPercent:120, skewY:6, scaleY:1.15, transformOrigin:'left top', willChange:'transform' });
      gsap.to(split.lines, {
        yPercent:0, skewY:0, scaleY:1, duration:0.62, ease:E.pop, stagger:0.07,
        scrollTrigger:{ trigger:headline, start:'top 82%' },
        onComplete:function(){ gsap.set(split.lines, { clearProps:'transform,willChange' }); }
      });
    } else {
      gsap.set(headline, { yPercent:110, opacity:0 });
      gsap.to(headline, {
        yPercent:0, opacity:1, duration:0.62, ease:E.pop,
        scrollTrigger:{ trigger:headline, start:'top 82%' },
        onComplete:function(){ gsap.set(headline, { clearProps:'transform' }); }
      });
    }
  }
  revealHeadline();

  // re-split on resize so masks don't clip after a reflow
  var rt;
  function onResize(){
    clearTimeout(rt);
    rt = setTimeout(function(){
      if(split){
        try{ split.revert(); }catch(e){}
        split = null;
        if(headline) gsap.set(headline, { clearProps:'all' });
      }
      ST && ST.refresh();
    }, 200);
  }
  window.addEventListener('resize', onResize);

  // ---------- eyebrow / sub / meter rise ----------
  var riseNodes = rises.filter(function(n){ return n !== headline; });
  if(riseNodes.length){
    gsap.set(riseNodes, { y:32, opacity:0 });
    gsap.to(riseNodes, {
      y:0, opacity:1, duration:0.5, ease:E.pop, stagger:0.06,
      scrollTrigger:{ trigger:root, start:'top 80%' },
      onComplete:function(){ gsap.set(riseNodes, { clearProps:'transform' }); }
    });
  }

  // ---------- meter reset: JS earns the fill + count in lockstep with tiles ----------
  if(fill) gsap.set(fill, { scaleX:0, transformOrigin:'left center' });
  paint(0);
  var counter = { v:0 };

  // ---------- master timeline: each tile locks pop + shine + badge + ring + meter notch + count ----------
  var grid = root.querySelector('.fpk-oc-grid');
  gsap.set(cards, {
    y:44, scale:0.9, opacity:0, willChange:'transform',
    rotate:function(i){ return i % 2 ? 2.5 : -2.5; }
  });

  var master = gsap.timeline({
    scrollTrigger:{ trigger:grid, start:'top 80%', once:true },
    onComplete:function(){ gsap.set(cards, { clearProps:'transform,willChange' }); }
  });

  cards.forEach(function(card, i){
    var shine = card.querySelector('[data-fpk-cardshine]');
    var badge = card.querySelector('[data-fpk-badge]');
    var ring  = card.querySelector('.fpk-oc-ring');
    var at = i * 0.14; // keep every sub-beat locked to its tile

    // tile pops in
    master.to(card, {
      y:0, scale:1, rotate:0, opacity:1, duration:0.55, ease:E.pop,
      onStart:function(){ card.style.pointerEvents = 'auto'; }
    }, at);

    // badge unlock spring — clearProps so CSS :hover reaction isn't blocked by leftover inline transform
    if(badge){
      master.fromTo(badge, { scale:0.4, rotate:-40 }, {
        scale:1, rotate:0, duration:0.55, ease:E.spring,
        onComplete:function(){ gsap.set(badge, { clearProps:'transform' }); }
      }, at + 0.08);
    }
    if(ring){
      master.fromTo(ring, { opacity:0.9, scale:0.7 }, {
        opacity:0, scale:1.5, duration:0.7, ease:'power2.out',
        onComplete:function(){ gsap.set(ring, { clearProps:'transform' }); }
      }, at + 0.08);
    }
    // shine sweep across the tile
    if(shine){
      master.fromTo(shine, { xPercent:-170, opacity:0 }, {
        xPercent:260, opacity:1, duration:0.7, ease:'power2.inOut',
        onComplete:function(){ gsap.to(shine, { opacity:0, duration:0.2 }); }
      }, at + 0.1);
    }
    // meter earns exactly one notch as this achievement lands
    if(fill){
      master.to(fill, { scaleX:(i + 1) / TOTAL, duration:0.4, ease:'power3.out' }, at + 0.08);
    }
    // counter ticks 0 -> 6, snapped to whole steps, same beat
    master.to(counter, {
      v:i + 1, duration:0.4, ease:'power1.out', snap:{ v:1 },
      onUpdate:function(){ paint(Math.round(counter.v)); }
    }, at + 0.08);
    if(pLabel){
      master.to(pLabel, { scale:1.22, duration:0.14, ease:'power2.out', yoyo:true, repeat:1 }, at + 0.08);
    }
  });

  // meter shine sweep once fully unlocked
  if(pShine){
    master.fromTo(pShine, { xPercent:-160, opacity:0 }, {
      xPercent:340, opacity:1, duration:0.7, ease:'power2.inOut',
      onComplete:function(){ gsap.to(pShine, { opacity:0, duration:0.2 }); }
    }, '>-0.1');
  }

  // ---------- per-card micro-interactions (fine pointers only) ----------
  cards.forEach(function(card){
    var shine = card.querySelector('[data-fpk-cardshine]');
    if(!fine) return;

    card.classList.add('is-magnetic');
    var xTo = gsap.quickTo(card, 'x', { duration:0.45, ease:'power3' });
    var yTo = gsap.quickTo(card, 'y', { duration:0.45, ease:'power3' });

    card.addEventListener('pointerenter', function(){
      card.style.willChange = 'transform';
      if(shine){
        gsap.fromTo(shine, { xPercent:-170, opacity:1 }, {
          xPercent:260, opacity:1, duration:0.7, ease:'power2.inOut',
          onComplete:function(){ gsap.to(shine, { opacity:0, duration:0.2 }); }
        });
      }
    });

    // magnetic pull toward cursor (+ subtle lift), spring back on leave
    card.addEventListener('pointermove', function(e){
      var r = card.getBoundingClientRect();
      var mx = (e.clientX - r.left) / r.width - 0.5;
      var my = (e.clientY - r.top) / r.height - 0.5;
      xTo(mx * 16);
      yTo(my * 12 - 6);
    });
    card.addEventListener('pointerleave', function(){
      gsap.to(card, {
        x:0, y:0, duration:0.6, ease:'back.out(2)',
        onComplete:function(){ card.style.willChange = 'auto'; }
      });
    });

    // green click ripple + cursor-punch recoil (scale composes with magnetic x/y)
    card.addEventListener('pointerdown', function(e){
      var r = card.getBoundingClientRect();
      var rp = document.createElement('span');
      rp.className = 'fpk-ripple';
      rp.style.left = (e.clientX - r.left) + 'px';
      rp.style.top = (e.clientY - r.top) + 'px';
      card.appendChild(rp);
      gsap.fromTo(rp, { scale:0, opacity:0.42 }, {
        scale:4, opacity:0, duration:0.6, ease:'power2.out',
        onComplete:function(){ rp.remove(); }
      });
      gsap.to(card, { scale:0.96, duration:0.09, ease:E.in, yoyo:true, repeat:1 });
    });
  });
};

;(window.FPK=window.FPK||{})._outcomesXA=function(root,ctx){
  var g=ctx.gsap; if(ctx.reduce||!g) return;
  var cards=Array.prototype.slice.call(root.querySelectorAll('[data-fpk="outcomes"] [class*="card"], .fpk-out-card, .fpk-oc-card'));
};






})();

;(function(){






(window.FPK = window.FPK || {}).testimonials = function (root, ctx) {
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger, reduce = !!ctx.reduce;

  // FIX 2: don't trust the harness to supply ctx.fine — the v2 reference computes it
  // itself. Fall back to matchMedia locally so the magnetic-tilt + shine hover lift
  // (a named must-have) still attaches on fine-pointer devices when ctx omits fine.
  var fine = ctx.fine != null
    ? !!ctx.fine
    : !!(window.matchMedia && window.matchMedia('(pointer:fine)').matches);

  var head     = root.querySelector('[data-t-head]');
  var headline = root.querySelector('[data-t-headline]');
  var rises    = Array.prototype.slice.call(root.querySelectorAll('[data-rise]'));
  var cards    = Array.prototype.slice.call(root.querySelectorAll('[data-t-card]'));

  // NOTE (fix 4): the raw v2 file also has a numeric scoreboard (4.9/5 odometer,
  // 248+ reviews, 98% meter fill+shine+ping). That is intentionally scoped OUT here:
  // the must-have is the 3-card grid, and those figures are fabricated stats, which
  // the project's non-negotiable brand rules forbid. The one brand-verifiable up-top
  // kinetic beat from the reference — the mentor credential (Rohit Khatri) — IS ported
  // and rides the shared [data-rise] machinery below.

  // ---------- REDUCE / NO-MOTION: final visible resting state, no triggers ----------
  if (reduce || !gsap || !ST) {
    root.querySelectorAll('[data-t-star]').forEach(function (s) {
      s.classList.add('is-on'); s.style.opacity = 1;
    });
    return; // CSS base (no .fpk-anim) already shows everything
  }

  root.classList.add('fpk-anim');
  // FIX 1: explicitly register ScrollTrigger (mirroring the v2 reference) so the whole
  // reveal never silently no-ops when the FPK loader hasn't pre-registered the plugin —
  // otherwise the cards stay opacity:0 (hidden by .fpk-anim) forever.
  if (gsap && ST) gsap.registerPlugin(ST);

  var E = { pop: 'back.out(1.7)', snap: 'back.out(2.4)', spring: 'elastic.out(1,0.55)', settle: 'power4.out' };

  // ---------- KINETIC HEADLINE (char mask + skew + accent overshoot) ----------
  if (headline && ctx.SplitType) {
    var split = new ctx.SplitType(headline, { types: 'lines,chars' });
    split.lines.forEach(function (l) {
      var w = document.createElement('span');
      w.style.cssText = 'display:block;overflow:hidden;padding-bottom:.14em;';
      l.parentNode.insertBefore(w, l);
      w.appendChild(l);
    });
    gsap.set(split.chars, { yPercent: 120, skewY: 7, rotate: 4, transformOrigin: 'left top' });
    gsap.to(split.chars, {
      yPercent: 0, skewY: 0, rotate: 0, duration: 0.72, ease: E.pop, stagger: 0.026,
      scrollTrigger: { trigger: headline, start: 'top 84%' }, // FIX 3: align to reference
      onComplete: function () { gsap.set(split.chars, { clearProps: 'transform' }); }
    });
    var accentChars = headline.querySelectorAll('.fpk-t-accent .char');
    if (accentChars.length) {
      gsap.fromTo(accentChars, { scale: 1.55 },
        { scale: 1, duration: 0.6, ease: E.spring, stagger: 0.026, delay: 0.18,
          scrollTrigger: { trigger: headline, start: 'top 84%' } }); // FIX 3
    }
  } else if (headline) {
    gsap.from(headline, { y: 30, opacity: 0, duration: 0.6, ease: E.pop,
      scrollTrigger: { trigger: headline, start: 'top 84%' } }); // FIX 3
  }

  // ---------- eyebrow + mentor-credential rise ----------
  if (rises.length) {
    gsap.set(rises, { y: 30, opacity: 0 });
    gsap.to(rises, {
      y: 0, opacity: 1, duration: 0.5, ease: E.pop, stagger: 0.08,
      scrollTrigger: { trigger: head, start: 'top 80%' }, // FIX 3
      onComplete: function () { gsap.set(rises, { clearProps: 'transform' }); }
    });
  }

  // ---------- SIGNATURE: each card pops on ITS OWN entrance, stars snap inside the same beat ----------
  gsap.set(cards, { y: 46, scale: 0.9, opacity: 0, rotate: function (i) { return i % 2 ? 3 : -3; } });

  function revealCard(card, delay) {
    var stars  = Array.prototype.slice.call(card.querySelectorAll('[data-t-star]'));
    var chip   = card.querySelector('[data-t-chip]');
    var shine  = card.querySelector('[data-t-shine]');
    stars.forEach(function (s) { s.classList.add('is-on'); });

    var tl = gsap.timeline({ delay: delay });
    // card body punches in (back.out)
    tl.to(card, { y: 0, scale: 1, opacity: 1, rotate: 0, duration: 0.58, ease: E.pop }, 0);
    // the 5 stars snap/draw in as PART of the same entrance (~0.16s after the card lands)
    tl.fromTo(stars, { scale: 0, opacity: 0, rotate: -35 },
      { scale: 1, opacity: 1, rotate: 0, duration: 0.4, ease: E.snap, stagger: 0.05 }, 0.16);
    // quote chip pops (aligned to the reference's badge beat at 0.34)
    if (chip) tl.fromTo(chip, { scale: 0.6, opacity: 0 },
      { scale: 1, opacity: 1, duration: 0.42, ease: E.snap }, 0.34);
    // FIX 5: avatar pop dropped for strict fidelity — the monogram appears with the card
    // (as in the reference), no separate scale-pop.
    // one shine sweep on reveal
    if (shine) tl.fromTo(shine, { xPercent: -160 },
      { xPercent: 260, duration: 0.75, ease: 'power2.inOut' }, 0.1);
    // hand transform back to the hover micro-interaction
    tl.add(function () { gsap.set(card, { clearProps: 'transform' }); });
    return tl;
  }

  // batch = every card fires when IT enters, center-out cascade within the entering row
  ST.batch(cards, {
    start: 'top 86%', // FIX 3
    onEnter: function (batch) {
      var fresh = batch.filter(function (c) { return !c._revealed; });
      if (!fresh.length) return;
      var n = fresh.length;
      fresh.forEach(function (card, i) {
        card._revealed = true;
        var delay = Math.abs(i - (n - 1) / 2) * 0.08; // FIX 3: match reference cascade
        revealCard(card, delay);
        card.style.pointerEvents = 'auto';
      });
    }
  });

  // ---------- micro: subtle magnetic tilt + hover shine (the hover lift) ----------
  if (fine) {
    var maxT = 8; // clamp translate so hover reads as a tilt, never a slide into neighbours
    cards.forEach(function (el) {
      var shine = el.querySelector('[data-t-shine]');
      el.addEventListener('pointerenter', function () {
        if (shine) gsap.fromTo(shine, { xPercent: -160 },
          { xPercent: 260, duration: 0.75, ease: 'power2.inOut' });
      });
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var nx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
        var ny = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
        // FIX 5: strict fidelity — ny * maxT with no -2 upward bias (matches reference)
        gsap.to(el, { x: nx * maxT, y: ny * maxT, rotateX: -ny * 3, rotateY: nx * 3,
          duration: 0.5, ease: E.settle, overwrite: 'auto' });
      });
      el.addEventListener('pointerleave', function () {
        gsap.to(el, { x: 0, y: 0, rotateX: 0, rotateY: 0, duration: 0.6, ease: E.spring, overwrite: 'auto' });
      });
    });
  }
};






})();

;(function(){






(window.FPK = window.FPK || {}).faq = function(root, ctx){
  ctx = ctx || {};
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger, SplitType = ctx.SplitType;
  var reduce = !!ctx.reduce;
  var fine = (ctx.fine != null) ? !!ctx.fine
           : !!(window.matchMedia && window.matchMedia('(pointer:fine)').matches);

  var sec = (root && root.matches && root.matches('[data-fpk="faq"]'))
            ? root
            : ((root && root.querySelector && root.querySelector('[data-fpk="faq"]')) || root);
  if(!sec) return;

  // Progressive-enhancement flag: JS present => the accordion may collapse bodies.
  // Without this class the CSS leaves every answer open + readable (fix 6).
  sec.classList.add('fpk-js');

  var headline = sec.querySelector('[data-fpk-headline]');
  var rises    = Array.prototype.slice.call(sec.querySelectorAll('[data-fpk-rise]'));
  var rows     = Array.prototype.slice.call(sec.querySelectorAll('[data-fpk-row]'));
  var cols     = sec.querySelector('[data-fpk-cols]');
  var fill     = sec.querySelector('[data-fpk-fill]');
  var mShine   = sec.querySelector('[data-fpk-mshine]');
  var mLabel   = sec.querySelector('[data-fpk-mlabel]');
  var TOTAL    = rows.length || 8;

  var E = { pop:'back.out(1.7)', spring:'elastic.out(1,0.55)', snap:'back.out(2)', in:'power3.in' };
  var openCount = 0;
  var revealed  = false;

  function paint(){ if(mLabel) mLabel.textContent = openCount + ' / ' + TOTAL + ' answered'; }

  // ---------- body open/close primitives ----------
  function closeBody(row){
    var body = row.querySelector('[data-fpk-body]');
    if(!body) return;
    if(gsap && !reduce) gsap.to(body, { height:0, duration:0.4, ease:'power2.inOut', overwrite:true });
    else body.style.height = '0px';
  }
  function openBody(row){
    var body = row.querySelector('[data-fpk-body]');
    if(!body) return;
    var inner = body.firstElementChild;
    var h = inner ? inner.offsetHeight : 0;
    if(gsap && !reduce){
      gsap.fromTo(body, { height:0 }, { height:h, duration:0.45, ease:'power2.out', overwrite:true,
        onComplete:function(){ body.style.height = 'auto'; } });
    } else {
      body.style.height = 'auto';
    }
  }

  // ---------- rail "unlock" — true elastic overshoot on open (fix 3, uses E.spring) ----------
  function railOpen(row){
    if(!(gsap && !reduce)) return;                 // reduced/no-gsap: CSS is-open drives the rail
    var rail = row.querySelector('.fpk-rail');
    if(!rail) return;
    gsap.fromTo(rail, { scaleY:0, opacity:0 }, {
      scaleY:1, opacity:1, duration:0.62, ease:E.spring,
      transformOrigin:'center center', overwrite:true
    });
  }
  function railClose(row){
    if(!(gsap && !reduce)) return;
    var rail = row.querySelector('.fpk-rail');
    if(!rail) return;
    gsap.to(rail, { scaleY:0, opacity:0, duration:0.26, ease:'power2.in',
      transformOrigin:'center center', overwrite:true });
  }

  // ---------- click-driven meter (answered semantics preserved) ----------
  function setMeter(){
    var v = openCount / TOTAL;
    if(fill){
      if(gsap && !reduce) gsap.to(fill, { scaleX:v, duration:0.4, ease:'power3.out', overwrite:'auto' });
      else fill.style.transform = 'scaleX(' + v + ')';
    }
    paint();
    if(gsap && !reduce){
      if(mLabel) gsap.fromTo(mLabel, { scale:1.2 }, { scale:1, duration:0.42, ease:E.snap, overwrite:'auto' });
      if(openCount === TOTAL && mShine){
        gsap.fromTo(mShine, { xPercent:-160, opacity:0 },
          { xPercent:360, opacity:1, duration:0.7, ease:'power2.inOut',
            onComplete:function(){ gsap.to(mShine, { opacity:0, duration:0.2 }); } });
      }
    }
  }

  // ---------- accordion toggle (works with or without gsap) ----------
  function toggle(row){
    var head = row.querySelector('[data-fpk-head]');
    var isOpen = row.classList.contains('is-open');
    if(isOpen){
      row.classList.remove('is-open');
      if(head) head.setAttribute('aria-expanded','false');
      openCount = Math.max(0, openCount - 1);
      closeBody(row);
      railClose(row);
    } else {
      row.classList.add('is-open');
      if(head) head.setAttribute('aria-expanded','true');
      openCount++;
      openBody(row);
      railOpen(row);
    }
    setMeter();
  }

  rows.forEach(function(row){
    var head = row.querySelector('[data-fpk-head]');
    if(head) head.addEventListener('click', function(){ toggle(row); });
  });

  // ---------- reduced motion / no gsap: resting state, no ScrollTriggers ----------
  if(!gsap || reduce){
    rows.forEach(function(r){ r.style.opacity = '1'; r.style.pointerEvents = 'auto'; });
    rises.forEach(function(r){ r.style.opacity = '1'; });
    if(fill) fill.style.transform = 'scaleX(0)';
    paint();
    return;
  }

  // ================= animated path =================
  if(ST) gsap.registerPlugin(ST);
  sec.classList.add('fpk-anim'); // gate hidden states + lock initial ASAP

  // kinetic headline: mask + skew + scale reveal
  var split = null;
  function buildSplit(){
    if(!SplitType || !headline) return null;
    try{
      var t = new SplitType(headline, { types:'lines' });
      t.lines.forEach(function(l){
        var w = document.createElement('span');
        w.className = 'fpk-line-mask';
        l.parentNode.insertBefore(w, l);
        w.appendChild(l);
      });
      return t;
    }catch(e){ return null; }
  }
  split = buildSplit();
  if(split){
    gsap.set(split.lines, { yPercent:120, skewY:6, scaleY:1.15, transformOrigin:'left top', willChange:'transform' });
    gsap.to(split.lines, {
      yPercent:0, skewY:0, scaleY:1, duration:0.62, ease:E.pop, stagger:0.07,
      scrollTrigger:{ trigger:headline, start:'top 84%' },
      onComplete:function(){ gsap.set(split.lines, { clearProps:'transform,willChange' }); }
    });
  } else if(headline){
    gsap.set(headline, { yPercent:110, opacity:0 });
    gsap.to(headline, {
      yPercent:0, opacity:1, duration:0.62, ease:E.pop,
      scrollTrigger:{ trigger:headline, start:'top 84%' },
      onComplete:function(){ gsap.set(headline, { clearProps:'transform' }); }
    });
  }

  // re-split on resize so masks don't clip after reflow
  var rt;
  window.addEventListener('resize', function(){
    clearTimeout(rt);
    rt = setTimeout(function(){
      if(split){ try{ split.revert(); }catch(e){} split = null; if(headline) gsap.set(headline, { clearProps:'all' }); }
      if(ST) ST.refresh();
    }, 200);
  });

  // eyebrow + meter rise
  var riseNodes = rises.filter(function(n){ return n !== headline; });
  if(riseNodes.length){
    gsap.set(riseNodes, { y:28, opacity:0 });
    gsap.to(riseNodes, {
      y:0, opacity:1, duration:0.5, ease:E.pop, stagger:0.07,
      scrollTrigger:{ trigger:sec, start:'top 80%' },
      onComplete:function(){ gsap.set(riseNodes, { clearProps:'transform' }); }
    });
  }

  // meter starts empty
  if(fill) gsap.set(fill, { scaleX:0, transformOrigin:'left center' });
  paint();

  // rails: gsap owns them on the animated path (kill CSS transition so the elastic reads cleanly)
  rows.forEach(function(row){
    var rail = row.querySelector('.fpk-rail');
    if(rail){ rail.style.transition = 'none'; gsap.set(rail, { scaleY:0, opacity:0, transformOrigin:'center center' }); }
  });

  // rows stagger-reveal: punchier pop + alternating rotate + shine sweep (fix 5, matches ref)
  gsap.set(rows, {
    y:44, scale:0.9, opacity:0, willChange:'transform', transformOrigin:'center',
    rotate:function(i){ return i % 2 ? 2.5 : -2.5; }
  });

  // fix 2: scroll-lockstep meter choreography inside the master timeline.
  // As each tile lands the fill earns exactly one notch, a snapped counter ticks 0->N,
  // and the label punches (yoyo) — a direct port of the reference's climactic energy bar.
  // Intentional, semantics-preserving divergence: the fill/counter demo the 8 questions
  // "arriving", then drain back to the real click-driven "0 / 8 answered" on complete.
  var counter = { v:0 };
  var master = gsap.timeline({
    scrollTrigger:{ trigger:cols || sec, start:'top 82%', once:true },
    onComplete:function(){
      gsap.set(rows, { clearProps:'transform,willChange' });
      revealed = true;
      if(fill) gsap.to(fill, { scaleX:openCount / TOTAL, duration:0.5, ease:'power2.inOut' });
      paint();
      if(mLabel) gsap.fromTo(mLabel, { scale:1.18 }, { scale:1, duration:0.4, ease:E.snap });
    }
  });
  rows.forEach(function(row, i){
    var shine = row.querySelector('[data-fpk-shine]');
    var at = i * 0.12; // wider stagger -> punchier cascade
    master.to(row, {
      y:0, scale:1, rotate:0, opacity:1, duration:0.55, ease:E.pop,
      onStart:function(){ row.style.pointerEvents = 'auto'; }
    }, at);
    if(shine){
      master.fromTo(shine, { xPercent:-170, opacity:0 }, {
        xPercent:260, opacity:1, duration:0.7, ease:'power2.inOut',
        onComplete:function(){ gsap.to(shine, { opacity:0, duration:0.2 }); }
      }, at + 0.08);
    }
    if(fill){
      master.to(fill, { scaleX:(i + 1) / TOTAL, duration:0.4, ease:'power3.out' }, at + 0.08);
    }
    master.to(counter, {
      v:i + 1, duration:0.4, ease:'power1.out', snap:{ v:1 },
      onUpdate:function(){ if(mLabel) mLabel.textContent = Math.round(counter.v) + ' / ' + TOTAL + ' questions'; }
    }, at + 0.08);
    if(mLabel){
      master.to(mLabel, { scale:1.22, duration:0.14, ease:'power2.out', yoyo:true, repeat:1 }, at + 0.08);
    }
  });
  // meter shine sweep once fully charged
  if(mShine){
    master.fromTo(mShine, { xPercent:-160, opacity:0 }, {
      xPercent:360, opacity:1, duration:0.7, ease:'power2.inOut',
      onComplete:function(){ gsap.to(mShine, { opacity:0, duration:0.2 }); }
    }, '>-0.1');
  }

  // ---------- per-row micro-interactions ----------
  rows.forEach(function(row){
    var shine = row.querySelector('[data-fpk-shine]');
    var head  = row.querySelector('[data-fpk-head]');
    if(!head) return;

    // hover shine sweep (fine pointers)
    if(fine && shine){
      row.addEventListener('pointerenter', function(){
        gsap.fromTo(shine, { xPercent:-170, opacity:1 }, {
          xPercent:260, opacity:1, duration:0.7, ease:'power2.inOut',
          onComplete:function(){ gsap.to(shine, { opacity:0, duration:0.2 }); }
        });
      });
    }

    // fix 1: signature magnetic cursor-pull + subtle lift, spring back on leave (fine pointers)
    if(fine){
      row.classList.add('is-magnetic');
      var xTo = gsap.quickTo(row, 'x', { duration:0.45, ease:'power3' });
      var yTo = gsap.quickTo(row, 'y', { duration:0.45, ease:'power3' });
      row.addEventListener('pointermove', function(e){
        if(!revealed) return; // don't fight the reveal's y tween
        var r = row.getBoundingClientRect();
        var mx = (e.clientX - r.left) / r.width - 0.5;
        var my = (e.clientY - r.top) / r.height - 0.5;
        xTo(mx * 14);
        yTo(my * 10 - 5); // always slightly lifted while hovered
      });
      row.addEventListener('pointerleave', function(){
        gsap.to(row, { x:0, y:0, duration:0.6, ease:'back.out(2)', overwrite:'auto' });
      });
    }

    // fix 4: press recoil + green click ripple on pointerdown
    head.addEventListener('pointerdown', function(e){
      var r = row.getBoundingClientRect();
      var rp = document.createElement('span');
      rp.className = 'fpk-ripple';
      rp.style.left = (e.clientX - r.left) + 'px';
      rp.style.top = (e.clientY - r.top) + 'px';
      row.appendChild(rp);
      gsap.fromTo(rp, { scale:0, opacity:0.4 }, {
        scale:16, opacity:0, duration:0.6, ease:'power2.out',
        onComplete:function(){ rp.remove(); }
      });
      if(revealed){
        gsap.to(row, { scale:0.96, duration:0.09, ease:E.in, yoyo:true, repeat:1 });
      }
    });
  });
};






})();

;(function(){






(window.FPK=window.FPK||{}).final = function(root, ctx){
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger, reduce = !!ctx.reduce;
  var SplitType = ctx.SplitType;
  var fine = !!ctx.fine;

  var headEl  = root.querySelector('[data-head]');
  var priceEl = root.querySelector('[data-price]');
  var capEl   = root.querySelector('[data-cap]');
  var pctEl   = root.querySelector('[data-pct]');
  var hudFill = root.querySelector('.fpk-final-hud-fill');
  var hudShine= root.querySelector('.fpk-final-hud-shine');
  var badgeEl = root.querySelector('.fpk-final-datebadge');
  var flashEl = root.querySelector('.fpk-final-flash');
  var achvEl  = root.querySelector('[data-achv]');
  var primary = root.querySelector('.fpk-final-cta--primary');
  var canvas  = root.querySelector('.fpk-final-fx');
  var rises   = [].slice.call(root.querySelectorAll('[data-rise]'));
  var incitems= [].slice.call(root.querySelectorAll('.fpk-final-inc'));
  var checks  = [].slice.call(root.querySelectorAll('.fpk-final-check'));
  var btns    = [].slice.call(root.querySelectorAll('[data-magnetic]'));
  var burstBtn= root.querySelector('[data-burst]');

  var priceTo = priceEl ? +priceEl.getAttribute('data-to') : 1999;
  var capTo   = capEl ? +capEl.getAttribute('data-to') : 200;
  function fmtIN(v){ try { return Math.round(v).toLocaleString('en-IN'); } catch(e){ return String(Math.round(v)); } }

  /* REDUCE / NO-GSAP: final resting state, no motion, no triggers/loops */
  if (reduce || !gsap){
    if (priceEl) priceEl.textContent = fmtIN(priceTo);
    if (capEl)   capEl.textContent   = fmtIN(capTo);
    if (pctEl)   pctEl.textContent   = '100%';
    if (hudFill) hudFill.style.transform = 'scaleX(1)';
    return;
  }

  gsap.registerPlugin(ST);
  root.classList.add('fpk-anim');

  var E = { pop:'back.out(1.7)', snap:'back.out(2.4)', spring:'elastic.out(1,0.55)', settle:'power4.out', rush:'power2.in', in:'power3.in' };

  var listeners = [];
  function addL(el,type,fn){ el.addEventListener(type,fn); listeners.push(function(){ el.removeEventListener(type,fn); }); }

  /* particle burst: pre-rendered sprites + additive blend */
  var ctx2d = canvas ? canvas.getContext('2d') : null;
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var particles = [];
  var rafId = null, running = false;
  var GREENS = [[55,224,122],[18,184,106],[122,235,165],[183,226,199],[234,255,244]];
  var sprites = [];
  function makeSprites(){
    sprites = GREENS.map(function(rgb){
      var s=48, c=document.createElement('canvas'); c.width=c.height=s;
      var g=c.getContext('2d'), cx=s/2, base='rgba('+rgb[0]+','+rgb[1]+','+rgb[2];
      var grad=g.createRadialGradient(cx,cx,0,cx,cx,cx);
      grad.addColorStop(0, base+',1)');
      grad.addColorStop(0.25, base+',0.85)');
      grad.addColorStop(0.55, base+',0.3)');
      grad.addColorStop(1, base+',0)');
      g.fillStyle=grad; g.beginPath(); g.arc(cx,cx,cx,0,Math.PI*2); g.fill();
      return c;
    });
  }
  function sizeCanvas(){
    if (!canvas) return;
    var r=root.getBoundingClientRect();
    canvas.width  = Math.max(1, Math.round(r.width*dpr));
    canvas.height = Math.max(1, Math.round(r.height*dpr));
  }
  makeSprites(); sizeCanvas();
  var onResize=function(){ sizeCanvas(); };
  window.addEventListener('resize', onResize);

  function burst(originEl){
    if (!ctx2d) return;
    var el = originEl || primary || headEl || root;
    var rr=root.getBoundingClientRect(), er=el.getBoundingClientRect();
    var ox=(er.left+er.width/2-rr.left)*dpr;
    var oy=(er.top+er.height*0.62-rr.top)*dpr;
    var n=60;
    for (var i=0;i<n;i++){
      var ang=-Math.PI/2+(Math.random()-0.5)*Math.PI*1.9;
      var spd=(3+Math.random()*6.5)*dpr;
      particles.push({ x:ox, y:oy, vx:Math.cos(ang)*spd, vy:Math.sin(ang)*spd-1.2*dpr,
        life:1, decay:0.008+Math.random()*0.013, r:(4+Math.random()*9)*dpr,
        sp:sprites[(Math.random()*sprites.length)|0] });
    }
    if (!running){ running=true; rafId=requestAnimationFrame(tick); }
  }
  function tick(){
    if (!ctx2d){ running=false; return; }
    ctx2d.clearRect(0,0,canvas.width,canvas.height);
    ctx2d.globalCompositeOperation='lighter';
    var alive=0;
    for (var i=0;i<particles.length;i++){
      var p=particles[i]; if (p.life<=0) continue; alive++;
      p.vy+=0.16*dpr; p.vx*=0.986; p.x+=p.vx; p.y+=p.vy; p.life-=p.decay;
      var a=p.life<0?0:p.life; var sz=p.r*(0.4+0.6*a)*2;
      ctx2d.globalAlpha=a; ctx2d.drawImage(p.sp, p.x-sz/2, p.y-sz/2, sz, sz);
    }
    ctx2d.globalAlpha=1; ctx2d.globalCompositeOperation='source-over';
    if (alive>0){ rafId=requestAnimationFrame(tick); }
    else { running=false; particles.length=0; ctx2d.clearRect(0,0,canvas.width,canvas.height); }
  }

  /* headline: masked lines primed for the slam */
  var split=null, lines=null;
  if (headEl && SplitType){
    split=new SplitType(headEl, { types:'lines' });
    split.lines.forEach(function(l){
      var w=document.createElement('span'); w.className='fpk-line-mask';
      l.parentNode.insertBefore(w,l); w.appendChild(l);
    });
    lines=split.lines;
    gsap.set(lines, { yPercent:120, skewY:6 });
    gsap.set(headEl, { autoAlpha:1 });
  } else if (headEl){
    gsap.set(headEl, { autoAlpha:0, scale:1.16 });
  }

  gsap.set(rises, { y:34, opacity:0 });
  gsap.set(incitems, { y:22, opacity:0, scale:0.94 });
  gsap.set(checks, { scale:0 });
  /*pk*/
  if (capEl)   capEl.textContent='0';
  if (pctEl)   pctEl.textContent='0%';

  function sweepShine(btn){
    var shine=btn.querySelector('.fpk-final-shine'); if (!shine) return;
    gsap.fromTo(shine, { xPercent:-160, opacity:0 },
      { xPercent:260, opacity:1, duration:0.7, ease:'power2.inOut',
        onComplete:function(){ gsap.to(shine, { opacity:0, duration:0.2 }); } });
  }

  /* one master finale timeline (single ScrollTrigger)
     order: rise -> price counts + gauge FILLS (signature build) -> headline SLAMS + burst + achievement + lime spike, same climax frame */
  var counter={ p:0, c:0, pct:0 };
  var CLIMAX=1.2;
  var mtl=gsap.timeline({ scrollTrigger:{ trigger:root, start:'top 70%', once:true } });

  /* 1) kinetic block rise */
  mtl.to(rises, { y:0, opacity:1, duration:0.55, ease:E.pop, stagger:0.06,
    onComplete:function(){ gsap.set(rises, { clearProps:'transform' }); } }, 0);
  if (badgeEl) mtl.fromTo(badgeEl, { scale:0.84 }, { scale:1, duration:0.6, ease:E.pop }, 0);
  mtl.add(function(){ btns.forEach(sweepShine); }, 0.5);

  /* 2) BUILD — price + cap count up while the SEGMENTED GAUGE fills (the gamerscore-bar signature) */
  mtl.to(counter, { p:priceTo, duration:0.95, ease:'power2.out',
    onUpdate:function(){ if (priceEl) priceEl.textContent=fmtIN(counter.p); } }, 0.25);
  mtl.to(counter, { c:capTo, duration:0.95, ease:'power2.out',
    onUpdate:function(){ if (capEl) capEl.textContent=fmtIN(counter.c); } }, 0.25);
  mtl.to(counter, { pct:100, duration:0.9, ease:'power4.out',
    onUpdate:function(){ if (pctEl) pctEl.textContent=Math.round(counter.pct)+'%'; } }, 0.3);
  if (hudFill) mtl.fromTo(hudFill, { scaleX:0 }, { scaleX:1, duration:0.9, ease:'power4.out' }, 0.3);
  if (hudShine) mtl.fromTo(hudShine, { xPercent:-160, opacity:0 },
    { xPercent:320, opacity:1, duration:0.75, ease:'power2.inOut',
      onComplete:function(){ gsap.to(hudShine, { opacity:0, duration:0.2 }); } }, 0.5);
  if (priceEl) mtl.fromTo(priceEl, { scale:1.14 }, { scale:1, duration:0.5, ease:E.spring }, 1.05);

  /* 3) CLIMAX BEAT — lime energy spike + flash + burst, same frame */
  mtl.add(function(){
    root.classList.add('fpk-peak');
    if (primary) primary.classList.add('fpk-charged');
    if (flashEl) gsap.fromTo(flashEl, { opacity:0 }, { opacity:1, duration:0.14, ease:E.rush,
      onComplete:function(){ gsap.to(flashEl, { opacity:0, duration:0.7, ease:'power2.out' }); } });
    burst(headEl);
  }, CLIMAX);

  /* headline SLAMS — heavy back.out(2.4) overshoot + scale-down punch, then settles in */
  if (lines){
    mtl.to(lines, { yPercent:0, skewY:0, duration:0.5, ease:E.snap, stagger:0.06,
      onComplete:function(){ gsap.set(lines, { clearProps:'transform' }); } }, CLIMAX);
    mtl.fromTo(headEl, { scale:1.16 }, { scale:1, duration:0.5, ease:E.snap }, CLIMAX);
  } else if (headEl){
    mtl.to(headEl, { autoAlpha:1, scale:1, duration:0.5, ease:E.snap }, CLIMAX);
  }
  if (primary) mtl.to(primary, { scale:1.06, duration:0.16, yoyo:true, repeat:1, ease:'power2.out' }, CLIMAX);

  /* 4) ACHIEVEMENT UNLOCKED — spring pop-in + rush auto-dismiss on the climax beat */
  if (achvEl){
    mtl.fromTo(achvEl, { y:-26, opacity:0, scale:0.9 },
      { y:0, opacity:1, scale:1, duration:0.55, ease:E.snap }, CLIMAX+0.05);
    mtl.to(achvEl, { y:-18, opacity:0, duration:0.5, ease:E.rush }, CLIMAX+2.7);
  }

  /* 5) inclusions grid check-pops */
  mtl.to(incitems, { y:0, opacity:1, scale:1, duration:0.5, ease:E.pop, stagger:0.07,
    onComplete:function(){ gsap.set(incitems, { clearProps:'transform' }); } }, CLIMAX+0.12);
  mtl.to(checks, { scale:1, duration:0.5, ease:E.snap, stagger:0.07 }, CLIMAX+0.2);

  /* button micro-interactions: hover shine + magnetic + ripple */
  btns.forEach(function(btn){
    var label=btn.querySelector('.fpk-final-label');
    if (fine){
      addL(btn,'pointerenter',function(){ sweepShine(btn); });
      var s=0.3;
      addL(btn,'pointermove',function(e){
        var r=btn.getBoundingClientRect();
        var dx=(e.clientX-(r.left+r.width/2))*s;
        var dy=(e.clientY-(r.top+r.height/2))*s;
        gsap.to(btn,{x:dx,y:dy,duration:0.4,ease:E.settle,overwrite:'auto'});
        if(label) gsap.to(label,{x:dx*0.35,y:dy*0.35,duration:0.4,ease:E.settle,overwrite:'auto'});
      });
      addL(btn,'pointerleave',function(){
        gsap.to(btn,{x:0,y:0,duration:0.6,ease:E.spring,overwrite:'auto'});
        if(label) gsap.to(label,{x:0,y:0,duration:0.6,ease:E.spring,overwrite:'auto'});
      });
    }
    addL(btn,'pointerdown',function(e){
      var r=btn.getBoundingClientRect();
      var rp=document.createElement('span'); rp.className='fpk-final-ripple';
      rp.style.left=(e.clientX-r.left)+'px'; rp.style.top=(e.clientY-r.top)+'px';
      btn.appendChild(rp);
      gsap.fromTo(rp,{scale:0,opacity:0.5},{scale:4,opacity:0,duration:0.6,ease:'power2.out',onComplete:function(){ rp.remove(); }});
      gsap.to(btn,{scale:0.94,duration:0.09,ease:E.in,yoyo:true,repeat:1});
    });
  });
  if (burstBtn) addL(burstBtn,'click',function(){ burst(burstBtn); });

  /* cleanup */
  return function cleanup(){
    try { if (mtl){ if (mtl.scrollTrigger) mtl.scrollTrigger.kill(); mtl.kill(); } } catch(e){}
    window.removeEventListener('resize', onResize);
    if (rafId) cancelAnimationFrame(rafId);
    running=false; particles.length=0;
    listeners.forEach(function(rm){ try{ rm(); }catch(e){} });
    try { if (split) split.revert(); } catch(e){}
    root.classList.remove('fpk-anim','fpk-peak');
    if (primary) primary.classList.remove('fpk-charged');
  };
};






})();

;(function(){






(window.FPK = window.FPK || {}).sticky = function(root, ctx){
  var gsap   = ctx && ctx.gsap;
  var reduce = !!(ctx && ctx.reduce);
  var fine   = ctx && ctx.fine != null ? !!ctx.fine
             : !!(window.matchMedia && matchMedia('(pointer:fine)').matches);

  var bar        = root;
  var priceEl    = root.querySelector('[data-fpk-count]');
  var rises      = [].slice.call(root.querySelectorAll('[data-fpk-rise]'));
  var brackets   = [].slice.call(root.querySelectorAll('.fpk-sticky-c'));
  var topfill    = root.querySelector('.fpk-sticky-topfill');
  var topshine   = root.querySelector('.fpk-sticky-topshine');
  var sweep      = root.querySelector('.fpk-sticky-sweep');
  var titleInner = root.querySelector('[data-fpk-title]');
  var flashEl    = root.querySelector('.fpk-sticky-flash');
  var chip       = root.querySelector('[data-fpk-achv]');
  var canvas     = root.querySelector('.fpk-sticky-fx');
  var btn        = root.querySelector('[data-fpk-magnetic]');

  var priceTo     = priceEl ? +priceEl.getAttribute('data-fpk-count') : 0;
  var pricePrefix = priceEl ? (priceEl.getAttribute('data-fpk-prefix') || '') : '';
  function fmtPrice(v){
    var n = Math.round(v), s;
    try { s = n.toLocaleString('en-IN'); } catch(e){ s = String(n); }
    return pricePrefix + s;
  }

  /* ---- REDUCE / NO-GSAP: final visible resting state, no motion, no triggers ---- */
  if (reduce || !gsap){
    if (priceEl) priceEl.textContent = fmtPrice(priceTo);
    root.classList.add('fpk-show');
    return;
  }

  root.classList.add('fpk-anim');

  var E = { pop:'back.out(1.7)', snap:'back.out(2.4)', spring:'elastic.out(1,0.55)', settle:'power4.out', inn:'power3.in' };

  var listeners = [];
  function addL(el, type, fn, opt){ el.addEventListener(type, fn, opt); listeners.push(function(){ el.removeEventListener(type, fn, opt); }); }

  /* primed hidden states */
  gsap.set(bar,       { yPercent:130 });
  gsap.set(rises,     { y:16, opacity:0 });
  gsap.set(brackets,  { scale:0, opacity:0, transformOrigin:'50% 50%' });
  if (topfill)    gsap.set(topfill,    { scaleX:0, transformOrigin:'left center' });
  if (titleInner) gsap.set(titleInner, { yPercent:110, skewY:5 });
  /*pk*/

  /* ================= climax particle burst — pre-rendered additive sprites ================= */
  var ctx2d = canvas ? canvas.getContext('2d') : null;
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var particles = [], rafId = null, running = false;
  var GREENS = [[55,224,122],[18,184,106],[122,235,165],[183,226,199],[234,255,244]];
  var sprites = [];
  function makeSprites(){
    sprites = GREENS.map(function(rgb){
      var s = 40, c = document.createElement('canvas'); c.width = c.height = s;
      var g = c.getContext('2d'), cx = s/2, base = 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2];
      var grad = g.createRadialGradient(cx, cx, 0, cx, cx, cx);
      grad.addColorStop(0, base + ',1)');
      grad.addColorStop(0.3, base + ',0.8)');
      grad.addColorStop(0.6, base + ',0.25)');
      grad.addColorStop(1, base + ',0)');
      g.fillStyle = grad; g.beginPath(); g.arc(cx, cx, cx, 0, Math.PI*2); g.fill();
      return c;
    });
  }
  function sizeCanvas(){
    if (!canvas) return;
    var r = canvas.getBoundingClientRect();
    canvas.width  = Math.max(1, Math.round(r.width  * dpr));
    canvas.height = Math.max(1, Math.round(r.height * dpr));
  }
  makeSprites(); sizeCanvas();
  addL(window, 'resize', sizeCanvas);

  function burst(){
    if (!ctx2d) return;
    var cr = canvas.getBoundingClientRect();
    var el = btn || root, er = el.getBoundingClientRect();
    var ox = (er.left + er.width/2 - cr.left) * dpr;         // origin tracks the real Enroll button
    var oy = (er.top  + er.height/2 - cr.top ) * dpr;
    var n = 34;
    for (var i=0; i<n; i++){
      var ang = -Math.PI/2 + (Math.random()-0.5) * Math.PI * 1.7;   // fan upward out of the bar
      var spd = (2.4 + Math.random()*5.2) * dpr;
      particles.push({
        x:ox, y:oy,
        vx:Math.cos(ang)*spd, vy:Math.sin(ang)*spd - 1.0*dpr,
        life:1, decay:0.012 + Math.random()*0.016,
        r:(3 + Math.random()*7) * dpr,
        sp:sprites[(Math.random()*sprites.length)|0]
      });
    }
    if (!running){ running = true; rafId = requestAnimationFrame(tick); }
  }
  function tick(){
    if (!ctx2d){ running = false; return; }
    ctx2d.clearRect(0,0,canvas.width,canvas.height);
    ctx2d.globalCompositeOperation = 'lighter';
    var alive = 0;
    for (var i=0; i<particles.length; i++){
      var p = particles[i];
      if (p.life <= 0) continue;
      alive++;
      p.vy += 0.14*dpr; p.vx *= 0.985;
      p.x += p.vx; p.y += p.vy; p.life -= p.decay;
      var a = p.life < 0 ? 0 : p.life;
      var sz = p.r * (0.4 + 0.6*a) * 2;
      ctx2d.globalAlpha = a;
      ctx2d.drawImage(p.sp, p.x - sz/2, p.y - sz/2, sz, sz);
    }
    ctx2d.globalAlpha = 1; ctx2d.globalCompositeOperation = 'source-over';
    if (alive > 0){ rafId = requestAnimationFrame(tick); }
    else { running = false; particles.length = 0; ctx2d.clearRect(0,0,canvas.width,canvas.height); }
  }

  /* ---- shine helpers ---- */
  function sweepEl(el, dur){
    if (!el) return;
    gsap.fromTo(el, { xPercent:-160, opacity:0 },
      { xPercent:260, opacity:1, duration:dur || 0.75, ease:'power2.inOut',
        onComplete:function(){ gsap.to(el, { opacity:0, duration:0.2 }); } });
  }
  function sweepBtnShine(){
    if (!btn) return;
    var sh = btn.querySelector('.fpk-sticky-shine');
    if (!sh) return;
    gsap.fromTo(sh, { xPercent:-160, opacity:0 },
      { xPercent:260, opacity:1, duration:0.7, ease:'power2.inOut',
        onComplete:function(){ gsap.to(sh, { opacity:0, duration:0.2 }); } });
  }

  var played = false, tl = null, entranceComplete = false;
  var counter = { v:0 };
  var CLIMAX = 1.15; // lands the drop the frame the counter finishes (build -> drop)

  /* ONE achievement-pop entrance timeline.
     BUILD : slide+overshoot -> HUD load-line -> bracket snap -> TITLE SLAM -> content rise -> price counts up
     DROP  : (t=CLIMAX, after counter completes) peak + flash + burst + price spring-pop + bar sweep + btn shine + achievement chip */
  function playIn(){
    root.classList.add('fpk-show');
    if (played){ gsap.to(bar, { yPercent:0, duration:0.5, ease:E.pop, overwrite:'auto' }); return; } // fancy pass is once
    played = true;

    tl = gsap.timeline();

    /* ---- BUILD ---- */
    tl.to(bar, { yPercent:0, duration:0.72, ease:'back.out(1.9)' }, 0);
    if (topfill) tl.to(topfill, { scaleX:1, duration:0.7, ease:'power4.out' }, 0.16);
    tl.add(function(){ sweepEl(topshine, 0.7); }, 0.28);
    tl.to(brackets, { scale:1, opacity:1, duration:0.5, ease:E.snap, stagger:0.05 }, 0.20);

    /* SIGNATURE: masked title SLAM — yPercent + skewY overshoot on back.out(2.4) (the kinetic reveal) */
    if (titleInner) tl.fromTo(titleInner, { yPercent:110, skewY:5 },
        { yPercent:0, skewY:0, duration:0.62, ease:E.snap }, 0.22);

    tl.to(rises, { y:0, opacity:1, duration:0.5, ease:E.pop, stagger:0.06,
        onComplete:function(){ gsap.set(rises, { clearProps:'transform' }); entranceComplete = true; } }, 0.28);

    tl.to(counter, { v:priceTo, duration:0.85, ease:'power2.out',
        onUpdate:function(){ if (priceEl) priceEl.textContent = fmtPrice(counter.v); },
        onComplete:function(){ if (priceEl) priceEl.textContent = fmtPrice(priceTo); } }, 0.30);

    /* ---- DROP (single climax frame) ---- */
    tl.add(function(){
      root.classList.add('fpk-peak');
      if (btn) btn.classList.add('fpk-charged');
      if (flashEl) gsap.fromTo(flashEl, { opacity:0 },
        { opacity:1, duration:0.14, ease:'power2.in',
          onComplete:function(){ gsap.to(flashEl, { opacity:0, duration:0.6, ease:'power2.out' }); } });
      burst();
      gsap.delayedCall(0.9, function(){
        root.classList.remove('fpk-peak');
        if (btn) btn.classList.remove('fpk-charged');
      });
    }, CLIMAX);

    if (priceEl) tl.fromTo(priceEl, { scale:1.18 }, { scale:1, duration:0.5, ease:E.spring }, CLIMAX);
    if (btn)     tl.to(btn, { scale:1.05, duration:0.16, yoyo:true, repeat:1, ease:'power2.out' }, CLIMAX);
    tl.add(function(){ sweepEl(sweep, 0.85); }, CLIMAX);
    tl.add(function(){ sweepBtnShine(); }, CLIMAX + 0.05);

    if (chip){
      tl.fromTo(chip, { y:16, opacity:0, scale:0.9 },
          { y:0, opacity:1, scale:1, duration:0.55, ease:E.snap }, CLIMAX + 0.04);
      tl.to(chip, { y:10, opacity:0, duration:0.5, ease:'power2.in' }, CLIMAX + 2.7); // auto-dismiss
    }
  }
  function playOut(){
    root.classList.remove('fpk-show');
    gsap.to(bar, { yPercent:130, duration:0.45, ease:'power2.in', overwrite:'auto' });
  }

  /* ---- scroll gate: reveal after the hero has scrolled out (~one viewport) ---- */
  var shown = false, ticking = false;
  function threshold(){ return Math.max(120, window.innerHeight * 0.8); }
  function evaluate(){
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var t = threshold();
    if (!shown && y > t){ shown = true; playIn(); }
    else if (shown && y < t - 60){ shown = false; playOut(); }
  }
  function onScroll(){ if (!ticking){ ticking = true; requestAnimationFrame(evaluate); } }
  addL(window, 'scroll', onScroll, { passive:true });
  addL(window, 'resize', onScroll);
  evaluate();

  /* ---- button micro-interactions — gated behind entranceComplete so a stray pointermove
          during the 0.5s rise can NEVER overwrite the reveal tween ---- */
  if (btn){
    var label = btn.querySelector('.fpk-sticky-label');
    if (fine){
      addL(btn, 'pointerenter', function(){ if (entranceComplete) sweepBtnShine(); });
      var m = 0.3;
      addL(btn, 'pointermove', function(e){
        if (!entranceComplete) return;
        var r = btn.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width/2)) * m;
        var dy = (e.clientY - (r.top + r.height/2)) * m;
        gsap.to(btn, { x:dx, y:dy, duration:0.4, ease:E.settle, overwrite:'auto' });
        if (label) gsap.to(label, { x:dx*0.35, y:dy*0.35, duration:0.4, ease:E.settle, overwrite:'auto' });
      });
      addL(btn, 'pointerleave', function(){
        if (!entranceComplete) return;
        gsap.to(btn, { x:0, y:0, duration:0.6, ease:E.spring, overwrite:'auto' });
        if (label) gsap.to(label, { x:0, y:0, duration:0.6, ease:E.spring, overwrite:'auto' });
      });
    }
    addL(btn, 'pointerdown', function(e){
      var r = btn.getBoundingClientRect();
      var rp = document.createElement('span');
      rp.className = 'fpk-sticky-ripple';
      rp.style.left = (e.clientX - r.left) + 'px';
      rp.style.top  = (e.clientY - r.top) + 'px';
      btn.appendChild(rp);
      gsap.fromTo(rp, { scale:0, opacity:0.5 },
        { scale:4, opacity:0, duration:0.6, ease:'power2.out', onComplete:function(){ rp.remove(); } });
      if (entranceComplete) gsap.to(btn, { scale:0.94, duration:0.09, ease:E.inn, yoyo:true, repeat:1 });
    });
  }

  /* ---- cleanup ---- */
  return function cleanup(){
    listeners.forEach(function(rm){ try { rm(); } catch(e){} });
    try { if (tl) tl.kill(); } catch(e){}
    if (rafId) cancelAnimationFrame(rafId);
    running = false; particles.length = 0;
    try { gsap.killTweensOf([bar, rises, brackets, counter, topfill, topshine, sweep, titleInner, flashEl, chip, btn].filter(Boolean)); } catch(e){}
    root.classList.remove('fpk-anim','fpk-peak','fpk-show');
    if (btn) btn.classList.remove('fpk-charged');
  };
};






})();
;(function(){
(window.FPK = window.FPK || {}).roadmap = function (root, ctx) { root.classList.add('rd-js'); };
})();
;(function(){
/* ==== R36-TOOLS-K2 — "magnet ribbon" toolkit strip (port of motion-lab/tools-k2-magnet.html)
   Engine moves: (1) measured seamless marquee — clones + gsap fromTo x, repeat:-1, 40px/s cruise;
   (2) ScrollTrigger getVelocity boost + quickTo skewX spring; (3) hover eases tween timeScale
   to 0 / back (fine pointers only — a touch tap fires mouseenter with no mouseleave and would
   freeze the ribbon forever); (4) per-chip magnet quickTo x/y toward cursor + elastic return +
   pointerdown ripple; (5) masked heading slam (yPercent/skewY, back.out(1.7)) + chip deal-in
   stagger. No GSAP / reduced motion => module exits and markup's static wrapped grid stands. */
(window.FPK = window.FPK || {}).tools = function(root, ctx){
  ctx = ctx || {};
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger;
  var reduce = !!ctx.reduce;
  var rail  = root.querySelector('[data-tw-rail]');
  var track = root.querySelector('[data-tw-track]');
  var set   = root.querySelector('[data-tw-set]');
  if(!rail || !track || !set) return;
  if(!gsap || reduce) return;                         // static wrapped grid, no loops
  if(ST && gsap.registerPlugin){ try{ gsap.registerPlugin(ST); }catch(e){} }

  root.classList.add('fpk-anim');                     // grid -> masked ribbon mode (CSS)

  var fine = !!(window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches);

  /* ---------- 1. seamless measured marquee ---------- */
  var tween = null, hovered = false, sign = 1;
  var ribbonActive = !ST;                             // no ScrollTrigger => no onToggle gate, run from boot
  var boost = { v: 0 };
  var skew = gsap.quickTo(track, 'skewX', { duration:.5, ease:'power3.out' });

  function applyBoost(){
    if(!tween) return;
    if(hovered){ skew(0); return; }                   // hover physics owns timeScale while inside
    tween.timeScale(1 + boost.v);
    skew(sign * boost.v * 1.9);
  }

  function buildMarquee(){
    // clear previous clones
    Array.prototype.slice.call(track.children).forEach(function(el){ if(el !== set) el.remove(); });
    var setW = set.offsetWidth;
    if(!setW) return;
    var copies = Math.max(2, Math.ceil(rail.clientWidth / setW) + 1);
    for(var i = 1; i < copies; i++){
      var clone = set.cloneNode(true);
      clone.setAttribute('aria-hidden','true');
      track.appendChild(clone);
      // clones must never inherit the base set's pre-entrance hidden state
      // (resize-before-entrance would otherwise clone opacity:0/visibility:hidden forever)
      gsap.set(clone.querySelectorAll('.fpk-tw-chip'), { clearProps:'opacity,visibility,transform' });
    }
    if(tween) tween.kill();
    var dur = setW / 40;                              // 40 px/sec cruise
    // paused until the section's ScrollTrigger first activates — otherwise the track
    // drifts left while still below the viewport and the hidden base chips (deal-in
    // autoAlpha:0) scroll into view as a blank stretch before the entrance fires
    tween = gsap.fromTo(track, { x:0 }, { x:-setW, duration:dur, ease:'none', repeat:-1, paused:!ribbonActive });
    if(hovered) tween.timeScale(0);
    wireMagnet();                                     // clones need magnet too
  }
  buildMarquee();

  // Clash Display may swap in after load and change chip widths, leaving a seam at
  // the clone loop point — re-measure and rebuild once fonts are settled
  if(document.fonts && document.fonts.ready){
    document.fonts.ready.then(function(){ buildMarquee(); });
  }

  var rT;
  window.addEventListener('resize', function(){ clearTimeout(rT); rT = setTimeout(buildMarquee, 250); });

  /* ---------- 2. scroll-velocity boost + kinetic skew ---------- */
  if(ST){
    ST.create({
      trigger: root, start:'top bottom', end:'bottom top',
      onUpdate: function(self){
        var vel = self.getVelocity();
        sign = vel < 0 ? -1 : 1;
        boost.v = Math.max(boost.v, gsap.utils.clamp(0, 2.2, Math.abs(vel) / 900));
        applyBoost();
        gsap.to(boost, { v:0, duration:1.1, ease:'power2.out', overwrite:true, onUpdate:applyBoost });
      },
      onToggle: function(self){
        ribbonActive = self.isActive;                 // remembered so font/resize rebuilds keep state
        if(!tween) return;
        self.isActive ? tween.play() : tween.pause();
      }
    });
  }

  /* ---------- 3. hover = physics, not a CSS pause (fine pointers only) ---------- */
  if(fine){
    rail.addEventListener('mouseenter', function(){
      hovered = true;
      if(tween) gsap.to(tween, { timeScale:0, duration:.45, ease:'power2.out', overwrite:true });
      skew(0);
    });
    rail.addEventListener('mouseleave', function(){
      hovered = false;
      if(tween) gsap.to(tween, { timeScale:1, duration:.6, ease:'power2.out', overwrite:true });
    });
  }

  /* ---------- K2 signature: per-chip MAGNET + ripple (fine pointers only) ---------- */
  var MAG = 10; // max magnet pull px
  function wireMagnet(){
    if(!fine) return;
    var chips = track.querySelectorAll('.fpk-tw-chip');
    Array.prototype.forEach.call(chips, function(chip){
      if(chip.__twMagnet) return;
      chip.__twMagnet = true;
      var xTo = gsap.quickTo(chip, 'x', { duration:.35, ease:'power3.out' });
      var yTo = gsap.quickTo(chip, 'y', { duration:.35, ease:'power3.out' });

      chip.addEventListener('pointermove', function(e){
        var r = chip.getBoundingClientRect();
        xTo(gsap.utils.clamp(-MAG, MAG, (e.clientX - (r.left + r.width / 2)) * .28));
        yTo(gsap.utils.clamp(-MAG, MAG, (e.clientY - (r.top + r.height / 2)) * .42));
      });

      chip.addEventListener('pointerleave', function(){
        gsap.to(chip, { x:0, y:0, duration:.9, ease:'elastic.out(1,.34)', overwrite:'auto' });
        gsap.to(chip, { scale:1, duration:.5, ease:'elastic.out(1,.4)' });
      });

      chip.addEventListener('pointerdown', function(e){
        gsap.to(chip, { scale:.94, duration:.12, ease:'power2.out' });   // press squash
        var r = chip.getBoundingClientRect();
        var rip = document.createElement('span');
        rip.className = 'fpk-tw-ripple';
        rip.style.left = (e.clientX - r.left) + 'px';
        rip.style.top  = (e.clientY - r.top) + 'px';
        chip.appendChild(rip);
        gsap.fromTo(rip, { scale:0, opacity:.9 },
          { scale:1.6, opacity:0, duration:.75, ease:'power2.out',
            onComplete:function(){ rip.remove(); } });
      });

      chip.addEventListener('pointerup', function(){
        gsap.to(chip, { scale:1, duration:.55, ease:'elastic.out(1.2,.4)' });
      });
    });
  }

  /* ---------- 4. entrance slam: masked heading + divider + rises + chip deal-in ---------- */
  var lines   = root.querySelectorAll('.fpk-tw-line');
  var rises   = root.querySelectorAll('[data-tw-rise]');
  var divider = root.querySelector('[data-tw-divider]');
  var dealChips = set.querySelectorAll('.fpk-tw-chip'); // base set only; clones sit offscreen right

  gsap.set(lines, { yPercent:115, skewY:5 });
  if(divider) gsap.set(divider, { scaleX:0 });
  if(rises.length) gsap.set(rises, { y:14, autoAlpha:0 });
  gsap.set(dealChips, { y:22, autoAlpha:0, rotation:function(i){ return i % 2 ? 4 : -4; } });

  var tl = gsap.timeline(ST ? { scrollTrigger:{ trigger:root, start:'top 80%', once:true } } : {});
  if(rises.length) tl.to(rises, { y:0, autoAlpha:1, duration:.5, ease:'power3.out', stagger:.08 }, 0);
  tl.to(lines, { yPercent:0, skewY:0, duration:.7, ease:'back.out(1.7)', stagger:.09 }, .05);
  if(divider) tl.to(divider, { scaleX:1, duration:.6, ease:'power3.out' }, '-=.35');
  tl.to(dealChips, { y:0, autoAlpha:1, rotation:0, duration:.6, ease:'back.out(1.7)', stagger:.045 }, '-=.4');
};
})();
